import { DsIcon as e, ICON_NAMES as t } from "@frontends/ds-icons";
import { cn as n } from "@frontends/util-cn";
import { tv as r } from "tailwind-variants";
import { useTranslation as i } from "react-i18next";
import { Autocomplete as a, Button as o, ButtonContext as s, Calendar as c, CalendarCell as l, CalendarGrid as u, CalendarGridBody as d, CalendarGridHeader as f, CalendarHeaderCell as p, CalendarStateContext as m, Cell as h, CheckboxButton as g, CheckboxField as _, CheckboxGroup as v, Collection as y, Column as b, ColumnResizer as x, DateInput as S, DatePicker as C, DatePickerStateContext as w, DateRangePicker as T, DateRangePickerStateContext as ee, DateSegment as E, Dialog as D, DropZone as te, FieldError as ne, FileTrigger as re, Group as ie, Header as ae, Heading as oe, Input as se, Label as ce, Link as le, ListBox as ue, ListBoxItem as de, ListBoxSection as fe, ListLayout as pe, Menu as me, MenuItem as he, MenuSection as ge, MenuTrigger as _e, Modal as ve, ModalOverlay as ye, NumberField as be, OverlayArrow as xe, OverlayTriggerStateContext as Se, Popover as Ce, PreviewTrigger as we, ProgressBar as Te, RadioButton as Ee, RadioField as De, RadioGroup as Oe, RangeCalendar as ke, RangeCalendarStateContext as Ae, ResizableTableContainer as je, RouterProvider as Me, Row as Ne, SearchField as Pe, Select as Fe, SelectStateContext as Ie, SelectValue as Le, SelectionIndicator as Re, Separator as ze, SubmenuTrigger as Be, SwitchButton as Ve, SwitchField as He, Tab as Ue, TabList as We, TabPanel as Ge, TabPanels as Ke, Table as qe, TableBody as Je, TableFooter as Ye, TableHeader as Xe, Tabs as Ze, Tag as Qe, TagGroup as $e, TagList as et, Text as tt, TextArea as nt, TextField as rt, TimeField as it, ToggleButton as at, ToggleButtonGroup as ot, Token as st, TokenField as ct, TokenInput as lt, TooltipContext as ut, TooltipTrigger as dt, TooltipTriggerStateContext as ft, UNSTABLE_Toast as pt, UNSTABLE_ToastContent as mt, UNSTABLE_ToastQueue as ht, UNSTABLE_ToastRegion as gt, Virtualizer as _t, composeRenderProps as O, useFilter as vt, useTableOptions as yt } from "react-aria-components";
import { Fragment as k, jsx as A, jsxs as j } from "react/jsx-runtime";
import { twMerge as M } from "tailwind-merge";
import { Children as bt, Fragment as xt, createContext as St, createElement as Ct, isValidElement as wt, useCallback as Tt, useContext as N, useEffect as P, useId as Et, useLayoutEffect as Dt, useMemo as Ot, useRef as F, useState as I, useSyncExternalStore as kt } from "react";
import { FocusScope as At, Overlay as jt, UNSAFE_PortalProvider as Mt, mergeProps as Nt, useDateFormatter as Pt, useFocusRing as Ft, useLocale as It, useNumberFormatter as Lt, useOverlay as Rt, useOverlayPosition as zt, useTooltip as Bt, useTooltipTrigger as Vt, useUNSAFE_PortalContext as Ht } from "react-aria";
import { createPortal as Ut, flushSync as Wt } from "react-dom";
import { CalendarDate as Gt, Time as Kt, getLocalTimeZone as qt, getLocalTimeZone as L, parseDate as Jt, today as Yt, today as Xt } from "@internationalized/date";
import { marker as R } from "@frontends/util-i18n";
import { useOverlayTriggerState as Zt, useTooltipTriggerState as Qt } from "react-stately";
import { useControlledState as $t } from "react-stately/useControlledState";
import { useDisclosureGroupState as en } from "react-stately/useDisclosureGroupState";
var tn = {
	autocomplete: { noResults: "No results." },
	calendar: {
		aria: {
			nextYear: "Next year",
			openCalendar: "Open calendar",
			prevYear: "Previous year"
		},
		months: {
			april: "April",
			august: "August",
			december: "December",
			february: "February",
			january: "January",
			july: "July",
			june: "June",
			march: "March",
			may: "May",
			november: "November",
			october: "October",
			september: "September"
		},
		weekdays: {
			fri: "Fr",
			mon: "Mo",
			sat: "Sa",
			sun: "Su",
			thu: "Th",
			tue: "Tu",
			wed: "We"
		}
	},
	common: {
		apply: "Apply",
		cancel: "Cancel",
		clear: "Clear",
		close: "Close",
		remove: "Remove"
	},
	dateField: { placeholder: {
		day: "dd",
		month: "mm",
		year: "yyyy"
	} },
	pagination: {
		aria: {
			navigation: "Pagination",
			next: "Next page",
			page: "Page {{page}}",
			previous: "Previous page"
		},
		summary_one: "Showing {{from}} to {{to}} of {{total}} result",
		summary_other: "Showing {{from}} to {{to}} of {{total}} results"
	},
	picker: {
		selectDate: "Select date",
		selectDateRange: "Select date range",
		selectDateTime: "Select date and time"
	},
	select: { placeholder: "Select option" },
	sidebar: { aria: {
		collapse: "Collapse sidebar",
		expand: "Expand sidebar"
	} },
	socialButton: { continueWith: {
		apple: "Continue with Apple",
		google: "Continue with Google",
		sso: "Continue with SSO"
	} },
	timeField: {
		label: "Time",
		placeholder: {
			hours: "hh",
			minutes: "mm",
			seconds: "ss"
		}
	},
	toast: { region: "Notifications" }
}, nn = "ds-common", rn = "rounded-2xl bg-backgroundRaised shadow-base forced-colors:outline", an = "flex items-center justify-center px-3 py-4 text-center text-base/5 text-textSecondary select-none forced-colors:text-[GrayText]", on = "pointer-coarse:after:absolute pointer-coarse:after:top-1/2 pointer-coarse:after:left-1/2 pointer-coarse:after:size-[max(100%,--spacing(11))] pointer-coarse:after:-translate-x-1/2 pointer-coarse:after:-translate-y-1/2", z = "outline-brandPrimary outline-offset-2 forced-colors:outline-[Highlight] focus-visible:outline-solid focus-visible:outline-2", sn = "group/focus-ring", cn = "outline-brandPrimary outline-offset-2 forced-colors:outline-[Highlight] group-focus-visible/focus-ring:outline-solid group-focus-visible/focus-ring:outline-2", B = "opacity-disabled cursor-not-allowed", ln = "[scrollbar-width:thin] [scrollbar-color:color-mix(in_oklab,var(--textTertiary)_60%,transparent)_transparent]", un = "transition-none entering:animate-in entering:fade-in entering:ease-out entering:duration-200 entering:placement-bottom:motion-safe:slide-in-from-top-1 entering:placement-top:motion-safe:slide-in-from-bottom-1 entering:placement-left:motion-safe:slide-in-from-right-1 entering:placement-right:motion-safe:slide-in-from-left-1 exiting:animate-out exiting:fade-out exiting:ease-in exiting:duration-150 exiting:placement-bottom:motion-safe:slide-out-to-top-1 exiting:placement-top:motion-safe:slide-out-to-bottom-1 exiting:placement-left:motion-safe:slide-out-to-right-1 exiting:placement-right:motion-safe:slide-out-to-left-1", dn = 100;
//#endregion
//#region src/lib/i18n/useComponentTranslation.ts
function fn(e, t) {
	let n = t.split(".").reduce((e, t) => {
		if (e && typeof e == "object") return e[t];
	}, e);
	return typeof n == "string" ? n : void 0;
}
function pn(e, t) {
	return typeof t?.count == "number" ? t.count === 1 ? `${e}_one` : `${e}_other` : e;
}
function mn(e, t) {
	return t ? e.replace(/\{\{(\w+)\}\}/g, (e, n) => {
		let r = t[n];
		return r === void 0 ? e : String(r);
	}) : e;
}
var hn = {
	t: ((e, t) => {
		let n = tn;
		return mn(fn(n, pn(e, t)) ?? fn(n, e) ?? e, t);
	}),
	i18n: null,
	ready: !0
};
function V() {
	let e = i(nn, { useSuspense: !1 });
	return e.ready ? e : hn;
}
//#endregion
//#region src/lib/components/Button/shared/Spinner.tsx
function gn({ size: e, stroke: t }) {
	return /* @__PURE__ */ j("svg", {
		className: "animate-spin",
		width: e,
		height: e,
		viewBox: "0 0 24 24",
		stroke: t,
		"aria-hidden": "true",
		children: [/* @__PURE__ */ A("circle", {
			cx: "12",
			cy: "12",
			r: "10",
			strokeWidth: "4",
			fill: "none",
			className: "opacity-25"
		}), /* @__PURE__ */ A("circle", {
			cx: "12",
			cy: "12",
			r: "10",
			strokeWidth: "4",
			strokeLinecap: "round",
			fill: "none",
			pathLength: "100",
			strokeDasharray: "60 140",
			strokeDashoffset: "0"
		})]
	});
}
//#endregion
//#region src/lib/components/Button/DsButton.tsx
var _n = {
	xs: "sm",
	sm: "sm",
	md: "md",
	lg: "md",
	xl: "md"
}, vn = 16, yn = {
	primary: "var(--textOnBrandPrimary)",
	secondary: "var(--textPrimary)",
	soft: "var(--textBrand)",
	destructive: "var(--textDangerPrimary)",
	quiet: "var(--textPrimary)"
}, bn = r({
	base: `${z} relative inline-flex items-center justify-center gap-2 box-border font-medium whitespace-nowrap text-center transition cursor-pointer ${on}`,
	variants: {
		variant: {
			primary: "bg-brandPrimary text-textOnBrandPrimary hover:bg-brandPrimaryHover pressed:bg-brandPrimaryActive",
			secondary: "bg-backgroundMuted text-textPrimary inset-ring-1 inset-ring-borderSecondary hover:bg-backgroundMutedHover pressed:bg-backgroundActive",
			soft: "bg-brandPrimaryMuted text-textBrand hover:bg-brandPrimarySubtle pressed:bg-brandPrimaryStrong",
			destructive: "bg-backgroundDangerPrimary text-textDangerPrimary hover:bg-backgroundDangerSecondary pressed:bg-backgroundDangerTertiary",
			quiet: "bg-transparent text-textSecondary hover:bg-backgroundMuted pressed:bg-backgroundMutedHover pressed:text-textPrimary"
		},
		size: {
			xs: "min-w-12 px-2 py-1 text-sm",
			sm: "min-w-14 px-2 py-1 text-base",
			md: "min-w-16 px-2.5 py-1.5 text-base",
			lg: "min-w-18 px-3 py-2 text-base",
			xl: "min-w-20 px-3.5 py-2.5 text-base"
		},
		shape: {
			square: "",
			pill: "rounded-full"
		},
		isDisabled: { true: B },
		isPending: { true: "text-transparent" }
	},
	compoundVariants: [
		{
			shape: "square",
			size: ["xs", "sm"],
			class: "rounded-xs"
		},
		{
			shape: "square",
			size: [
				"md",
				"lg",
				"xl"
			],
			class: "rounded-md"
		},
		{
			shape: "pill",
			size: ["xs", "sm"],
			class: "px-2.5"
		},
		{
			shape: "pill",
			size: "md",
			class: "px-3"
		},
		{
			shape: "pill",
			size: "lg",
			class: "px-3.5"
		},
		{
			shape: "pill",
			size: "xl",
			class: "px-4"
		},
		{
			variant: "primary",
			isPending: !0,
			class: "bg-brandPrimaryHover"
		},
		{
			variant: "secondary",
			isPending: !0,
			class: "bg-backgroundMutedHover"
		},
		{
			variant: "soft",
			isPending: !0,
			class: "bg-brandPrimarySubtle"
		},
		{
			variant: "destructive",
			isPending: !0,
			class: "bg-backgroundDangerSecondary"
		}
	],
	defaultVariants: {
		variant: "primary",
		size: "md",
		shape: "square"
	}
});
function H({ variant: t = "primary", size: n = "md", shape: r = "square", iconStart: i, iconEnd: a, ...s }) {
	return /* @__PURE__ */ A(o, {
		...s,
		className: O(s.className, (e, i) => bn({
			...i,
			variant: t,
			size: n,
			shape: r,
			className: e
		})),
		children: O(s.children, (r, { isPending: o }) => /* @__PURE__ */ j(k, { children: [
			i && /* @__PURE__ */ A(e, {
				name: i,
				size: _n[n],
				"aria-hidden": !0
			}),
			r,
			a && /* @__PURE__ */ A(e, {
				name: a,
				size: _n[n],
				"aria-hidden": !0
			}),
			o && /* @__PURE__ */ A("span", {
				"aria-hidden": !0,
				className: "flex absolute inset-0 justify-center items-center",
				children: /* @__PURE__ */ A(gn, {
					size: vn,
					stroke: yn[t]
				})
			})
		] }))
	});
}
//#endregion
//#region src/lib/helpers/composeTailwindRenderProps.ts
function U(e, t) {
	return O(e, (e) => M(t, e));
}
//#endregion
//#region src/lib/helpers/surfaceStyles.ts
var W = r({
	slots: {
		surface: "ring-1 ring-borderSurface",
		arrow: "stroke-1 stroke-borderSurface"
	},
	variants: { level: {
		tooltip: {
			surface: "rounded-lg shadow-md bg-backgroundFloating",
			arrow: "fill-backgroundFloating"
		},
		menu: {
			surface: "rounded-md shadow-lg bg-backgroundFloating",
			arrow: "fill-backgroundFloating"
		},
		toast: { surface: "rounded-lg shadow-lg bg-backgroundFloating" },
		panel: { surface: "rounded-lg shadow-lg bg-backgroundRaised" },
		dialog: { surface: "rounded-2xl shadow-xl bg-backgroundRaised" },
		drawer: { surface: "shadow-xl bg-backgroundNav" }
	} }
}), xn = {
	top: {
		top: "100%",
		transform: "translateX(-50%)"
	},
	bottom: {
		bottom: "100%",
		transform: "translateX(-50%)"
	},
	left: {
		left: "100%",
		transform: "translateY(-50%)"
	},
	right: {
		right: "100%",
		transform: "translateY(-50%)"
	}
}, Sn = {
	top: "bottom",
	bottom: "top",
	left: "right",
	right: "left"
};
function Cn(e, t, n) {
	return Math.min(Math.max(e, t), n);
}
function wn(e, t) {
	let n = (e ?? "top").split(" ")[0];
	return n === "start" ? t === "rtl" ? "right" : "left" : n === "end" ? t === "rtl" ? "left" : "right" : n === "bottom" || n === "left" || n === "right" ? n : "top";
}
function Tn(e, t, n, r, i, a, o) {
	let s = {
		top: e.top - a - n >= r.top + o,
		bottom: e.bottom + a + n <= r.bottom - o,
		left: e.left - a - t >= r.left + o,
		right: e.right + a + t <= r.right - o
	}, c = s[i] || !s[Sn[i]] ? i : Sn[i];
	if (c === "top" || c === "bottom") {
		let i = c === "top" ? e.top - a - n : e.bottom + a;
		return {
			left: Cn(e.left + e.width / 2 - t / 2, r.left + o, r.right - o - t),
			top: i,
			placement: c
		};
	}
	return {
		left: c === "left" ? e.left - a - t : e.right + a,
		top: Cn(e.top + e.height / 2 - n / 2, r.top + o, r.bottom - o - n),
		placement: c
	};
}
//#endregion
//#region src/lib/components/Tooltip/components/hooks/useTooltipPosition.ts
function En({ offset: e, portalContainer: t, state: n, triggerRef: r, ...i }) {
	let a = F(null), o = F(null), s = !!(t && t.ownerDocument !== document), [c, l] = I(null), { direction: u } = It(), d = wn(i.placement, u), { overlayProps: f, arrowProps: p, placement: m } = zt({
		...i,
		placement: i.placement ?? "top",
		targetRef: r,
		overlayRef: a,
		arrowRef: o,
		offset: e,
		boundaryElement: t ?? void 0,
		isOpen: n.isOpen && !s,
		onClose: () => n.close(!0)
	});
	if (Dt(() => {
		if (!s || !n.isOpen) return;
		let o = a.current, c = r.current;
		!o || !c || !t || l(Tn(c.getBoundingClientRect(), o.offsetWidth, o.offsetHeight, t.getBoundingClientRect(), d, e, i.containerPadding ?? 12));
	}, [
		s,
		n.isOpen,
		t,
		r,
		d,
		e,
		i.containerPadding
	]), !s) return {
		arrowProps: p,
		arrowRef: o,
		overlayRef: a,
		placement: m,
		style: f.style ?? {}
	};
	let h = c ? {
		position: "absolute",
		left: c.left,
		top: c.top
	} : {
		position: "absolute",
		visibility: "hidden"
	};
	return {
		arrowProps: p,
		arrowRef: o,
		overlayRef: a,
		placement: c?.placement ?? d,
		style: h
	};
}
//#endregion
//#region src/lib/components/Tooltip/components/TooltipOverlay.tsx
var Dn = W({ level: "tooltip" }), On = r({ base: [
	`group pointer-events-none max-w-80 ${Dn.surface()} px-2 py-1`,
	"text-base/5 font-medium text-textPrimary wrap-break-word",
	"transition-none animate-in fade-in ease-out duration-200",
	"placement-bottom:motion-safe:slide-in-from-top-[--spacing(0.5)] placement-top:motion-safe:slide-in-from-bottom-[--spacing(0.5)]",
	"placement-left:motion-safe:slide-in-from-right-[--spacing(0.5)] placement-right:motion-safe:slide-in-from-left-[--spacing(0.5)]"
] }), kn = n(`block ${Dn.arrow()}`, "forced-colors:fill-[Canvas] forced-colors:stroke-[ButtonBorder]", "group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90");
function An({ state: e, triggerRef: t, showArrow: n, children: r, className: i, ...a }) {
	let { getContainer: o } = Ht(), s = o?.() ?? null, { tooltipProps: c } = Bt(a, e), l = a.offset ?? (n ? 10 : 6), { arrowProps: u, arrowRef: d, overlayRef: f, placement: p, style: m } = En({
		placement: a.placement,
		crossOffset: a.crossOffset,
		shouldFlip: a.shouldFlip,
		containerPadding: a.containerPadding,
		arrowBoundaryOffset: a.arrowBoundaryOffset,
		offset: l,
		portalContainer: s,
		state: e,
		triggerRef: t
	});
	return Ut(/* @__PURE__ */ j("div", {
		...c,
		ref: f,
		"data-placement": p ?? void 0,
		className: On({ className: typeof i == "string" ? i : void 0 }),
		style: {
			...m,
			zIndex: "var(--z-index-tooltip)"
		},
		children: [n && p && p !== "center" && /* @__PURE__ */ A("div", {
			ref: d,
			...u,
			className: "absolute",
			style: {
				...u.style,
				...xn[p]
			},
			children: /* @__PURE__ */ A("svg", {
				width: 8,
				height: 8,
				viewBox: "0 0 8 8",
				className: kn,
				children: /* @__PURE__ */ A("path", { d: "M0 0 L4 4 L8 0" })
			})
		}), r]
	}), s ?? document.body);
}
//#endregion
//#region src/lib/components/Tooltip/DsTooltip.tsx
function jn(e) {
	return /* @__PURE__ */ A(dt, {
		...e,
		delay: 100,
		closeDelay: 100
	});
}
function Mn({ children: e, anchor: t, showArrow: n, ...r }) {
	let i = N(ft), a = N(ut), o = t?.state ?? i, s = r.isOpen ?? o?.isOpen;
	if (!o || !s) return null;
	let c = a && "triggerRef" in a ? a.triggerRef : null, l = t?.triggerRef ?? c;
	if (!l) return null;
	let u = t?.tooltipProps.id ?? (a && "id" in a ? a.id : void 0);
	return /* @__PURE__ */ A(An, {
		...r,
		id: u,
		state: o,
		triggerRef: l,
		showArrow: n,
		children: e
	});
}
//#endregion
//#region src/lib/components/Button/IconButton/DsIconButton.tsx
var Nn = {
	sm: "shrink-0 min-w-0 p-1 rounded-md",
	md: "shrink-0 min-w-0 p-1.5"
}, Pn = "text-current hover:bg-transparent hover:text-current pressed:bg-transparent";
function Fn({ name: t, icon: r, size: i = "md", variant: a = "quiet", className: o, tooltip: s = "", tooltipPlacement: c, ...l }) {
	let u = /* @__PURE__ */ A(H, {
		...l,
		variant: a === "plain" ? "quiet" : a,
		size: i,
		className: U(o, n(Nn[i], a === "plain" && Pn)),
		children: t === void 0 ? r : /* @__PURE__ */ A(e, {
			name: t,
			size: i,
			"aria-hidden": !0
		})
	});
	return s ? /* @__PURE__ */ j(jn, { children: [u, /* @__PURE__ */ A(Mn, {
		placement: c,
		children: s
	})] }) : u;
}
//#endregion
//#region src/lib/components/Alert/DsAlert.tsx
var In = r({
	base: "flex items-start gap-3 rounded-md border px-4 py-3 min-w-[min(var(--container-sm),100%)]",
	variants: { variant: {
		success: "bg-backgroundSuccessPrimary border-borderSuccessPrimary text-textSuccessPrimary",
		warning: "bg-backgroundWarningPrimary border-borderWarningPrimary text-textWarningPrimary",
		danger: "bg-backgroundDangerPrimary border-borderDangerPrimary text-textDangerPrimary",
		info: "bg-backgroundInfoPrimary border-borderInfoPrimary text-textInfoPrimary",
		neutral: "bg-backgroundMuted border-borderSecondary text-textPrimary"
	} },
	defaultVariants: { variant: "info" }
}), Ln = {
	success: "circle-check",
	warning: "circle-alert",
	danger: "circle-x",
	info: "info",
	neutral: "info"
}, Rn = {
	success: "text-textSuccessPrimary",
	warning: "text-textWarningPrimary",
	danger: "text-textDangerPrimary",
	info: "text-textInfoPrimary",
	neutral: "text-textSecondary"
}, zn = { neutral: "text-textSecondary" }, Bn = {
	success: "bg-backgroundSuccessSecondary text-textSuccessPrimary not-disabled:hover:bg-backgroundSuccessTertiary pressed:bg-backgroundSuccessTertiary",
	warning: "bg-backgroundWarningSecondary text-textWarningPrimary not-disabled:hover:bg-backgroundWarningTertiary pressed:bg-backgroundWarningTertiary",
	danger: "bg-backgroundDangerSecondary text-textDangerPrimary not-disabled:hover:bg-backgroundDangerTertiary pressed:bg-backgroundDangerTertiary",
	info: "bg-backgroundInfoSecondary text-textInfoPrimary not-disabled:hover:bg-backgroundInfoTertiary pressed:bg-backgroundInfoTertiary",
	neutral: "bg-backgroundMuted text-textSecondary not-disabled:hover:bg-backgroundMutedHover pressed:bg-backgroundMutedHover"
}, Vn = ({ variant: t = "info", title: r, titleLevel: i, description: a, icon: o, showIcon: s = !0, showClose: c = !1, onOpenChange: l, actionLabel: u, onAction: d, className: f, ...p }) => {
	let { t: m } = V(), h = Rn[t], g = i === void 0 ? "p" : `h${i}`;
	return /* @__PURE__ */ j("div", {
		role: "alert",
		className: n(In({ variant: t }), f),
		...p,
		children: [
			s && /* @__PURE__ */ A(e, {
				name: o ?? Ln[t],
				size: "md",
				className: n("shrink-0", zn[t])
			}),
			/* @__PURE__ */ j("div", {
				className: "flex min-w-0 flex-1 flex-col items-start gap-1 wrap-break-word",
				children: [
					r && /* @__PURE__ */ A(g, {
						className: "text-base/5 font-medium",
						children: r
					}),
					a && /* @__PURE__ */ A("p", {
						className: n("text-base/5 opacity-85", h),
						children: a
					}),
					u && d && /* @__PURE__ */ A(H, {
						variant: "soft",
						size: "sm",
						className: n("max-w-full whitespace-normal", Bn[t]),
						onPress: d,
						children: u
					})
				]
			}),
			c && /* @__PURE__ */ A(Fn, {
				"aria-label": m("common.close"),
				size: "sm",
				name: "x",
				variant: "plain",
				onPress: () => l?.(!1),
				className: "shrink-0 -m-1 opacity-60 hover:opacity-100"
			})
		]
	});
}, Hn = "p-1 scroll-py-1 outline-0 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_var(--radius-md))]", Un = {
	padding: 4,
	estimatedRowSize: 40,
	estimatedHeadingSize: 28
}, Wn = {
	...Un,
	estimatedRowSize: 48
}, Gn = r({
	slots: {
		row: "group flex items-center gap-3 px-3 py-2 rounded-md text-base/6 cursor-pointer select-none outline-0 no-underline forced-color-adjust-none",
		checkSlot: "flex w-5 shrink-0 items-center justify-center",
		check: "text-textBrand forced-colors:text-current",
		icon: "shrink-0",
		content: "flex min-w-0 flex-1 gap-2",
		label: "min-w-0 truncate",
		description: "shrink-0 truncate text-textSecondary forced-colors:text-current",
		shortcut: "shrink-0 text-sm text-textTertiary forced-colors:text-current",
		submenu: "shrink-0"
	},
	variants: {
		size: {
			default: {},
			touch: { row: "py-3" }
		},
		variant: {
			default: { row: "text-textPrimary" },
			destructive: { row: "text-textDangerTertiary" }
		},
		isHighlighted: { true: { row: "bg-backgroundHover forced-colors:bg-[Highlight] forced-colors:text-[HighlightText]" } },
		isDisabled: { true: { row: `${B} forced-colors:text-[GrayText]` } }
	},
	defaultVariants: {
		size: "default",
		variant: "default"
	}
});
//#endregion
//#region src/lib/components/ListBox/components/DropdownItemContent.tsx
function Kn({ children: t, description: n, hasSubmenu: r = !1, iconStart: i, isSelected: a, selectionMode: o, shortcut: s, variant: c = "default" }) {
	let l = Gn({ variant: c });
	return /* @__PURE__ */ j(k, { children: [
		o !== "none" && /* @__PURE__ */ A("span", {
			className: l.checkSlot(),
			children: a && /* @__PURE__ */ A(e, {
				name: "check",
				"aria-hidden": !0,
				size: "md",
				className: l.check()
			})
		}),
		i && /* @__PURE__ */ A(e, {
			name: i,
			"aria-hidden": !0,
			size: "md",
			className: l.icon()
		}),
		/* @__PURE__ */ j("span", {
			className: l.content(),
			children: [/* @__PURE__ */ A("span", {
				className: l.label(),
				children: t
			}), n && /* @__PURE__ */ A("span", {
				className: l.description(),
				children: n
			})]
		}),
		s && /* @__PURE__ */ A("span", {
			className: l.shortcut(),
			children: s
		}),
		r && /* @__PURE__ */ A(e, {
			name: "chevron-right",
			"aria-hidden": !0,
			size: "sm",
			className: l.submenu()
		})
	] });
}
//#endregion
//#region src/lib/components/ListBox/DropdownItem.tsx
function qn(e) {
	let { iconStart: t, textEnd: n } = e, r = e.textValue || (typeof e.children == "string" ? e.children : void 0);
	return /* @__PURE__ */ A(de, {
		...e,
		textValue: r,
		className: O(e.className, (e, { isFocused: t, isDisabled: n }) => Gn({
			isHighlighted: t,
			isDisabled: n
		}).row({ className: e })),
		children: O(e.children, (e, { selectionMode: r, isSelected: i }) => /* @__PURE__ */ A(Kn, {
			iconStart: t,
			description: n,
			isSelected: i,
			selectionMode: r,
			children: e
		}))
	});
}
//#endregion
//#region src/lib/components/ListBox/hooks/useRevealFocusedRow.ts
var Jn = 30, Yn = 2, Xn = [
	"wheel",
	"touchstart",
	"pointerdown"
];
function Zn(e, t) {
	Dt(() => {
		let n = e.current;
		if (!n) return;
		let r = 0, i = null, a = () => cancelAnimationFrame(r), o = (e, t) => {
			let i = Jn, o = 0, s = NaN, c = NaN, l = () => {
				--i;
				let a = n.querySelector(e);
				if (a) {
					let e = n.getBoundingClientRect(), r = a.getBoundingClientRect(), i = r.top - e.top, l = i >= 0 && r.bottom <= e.bottom, u = i === s && n.scrollHeight === c;
					t === "center" && !u ? n.scrollTop += i - (n.clientHeight - r.height) / 2 : t === "nearest" && !l && a.scrollIntoView({ block: "nearest" }), o = l && u ? o + 1 : 0, s = i, c = n.scrollHeight;
				}
				o < Yn && i > 0 && (r = requestAnimationFrame(l));
			};
			a(), r = requestAnimationFrame(l);
		}, s = t ? new MutationObserver(() => {
			let e = n.querySelector("[data-focus-visible]")?.getAttribute("data-key") ?? null;
			e !== i && (i = e, e !== null && o(`[data-key="${CSS.escape(e)}"]`, "nearest"));
		}) : null;
		return s?.observe(n, {
			subtree: !0,
			childList: !0,
			attributeFilter: ["data-focus-visible"]
		}), Xn.forEach((e) => n.addEventListener(e, a, { passive: !0 })), o("[data-focused]", "center"), () => {
			s?.disconnect(), Xn.forEach((e) => n.removeEventListener(e, a)), a();
		};
	}, [t, e]);
}
//#endregion
//#region src/lib/components/ListBox/DropdownListBox.tsx
function Qn({ className: e, itemCount: t, ...r }) {
	let i = F(null), a = t > 50;
	Zn(i, a);
	let o = /* @__PURE__ */ A(ue, {
		...r,
		ref: i,
		className: n(e, a && "block p-0 contain-inline-size min-w-(--trigger-width)")
	});
	return a ? /* @__PURE__ */ A(_t, {
		layout: pe,
		layoutOptions: Un,
		children: o
	}) : o;
}
//#endregion
//#region src/lib/components/ListBox/DropdownSection.tsx
function $n(e) {
	return /* @__PURE__ */ A(ae, {
		...e,
		className: M("px-3 pt-2 pb-1 text-sm/4 font-medium text-textSecondary truncate", e.className)
	});
}
function er(e) {
	return /* @__PURE__ */ j(fe, {
		...e,
		children: [e.title && /* @__PURE__ */ A($n, { children: e.title }), /* @__PURE__ */ A(y, {
			items: e.items,
			children: e.children
		})]
	});
}
//#endregion
//#region src/lib/hooks/usePortalBoundary.ts
function tr() {
	let { getContainer: e } = Ht(), t = e?.();
	if (!t) return;
	let n = t.getRootNode();
	if (n && "host" in n) return n.host;
	if (t.ownerDocument !== document) return t.parentElement ?? t;
}
//#endregion
//#region src/lib/components/Popover/DsPopover.tsx
var nr = W({ level: "menu" }), rr = r({ base: `${nr.surface()} ${un} forced-colors:bg-[Canvas] text-textPrimary outline-0` });
function ir({ children: e, showArrow: t, className: n, style: r, ...i }) {
	return /* @__PURE__ */ j(Ce, {
		offset: t ? 12 : 6,
		boundaryElement: tr(),
		...i,
		style: typeof r == "function" ? r : {
			zIndex: "var(--z-index-popover)",
			...r
		},
		className: O(n, (e) => rr({ className: e })),
		children: [t && /* @__PURE__ */ A(xe, {
			className: "group",
			children: /* @__PURE__ */ A("svg", {
				width: 12,
				height: 12,
				viewBox: "0 0 12 12",
				className: `block ${nr.arrow()} forced-colors:fill-[Canvas] forced-colors:stroke-[ButtonBorder] group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90`,
				children: /* @__PURE__ */ A("path", { d: "M0 0 L6 6 L12 0" })
			})
		}), e]
	});
}
//#endregion
//#region src/lib/components/Menu/helpers/MenuLayout.ts
var ar = class extends pe {
	buildNode(e, t, n) {
		return e.type === "submenutrigger" ? this.buildSection(e, t, n) : super.buildNode(e, t, n);
	}
}, or = St("default");
function sr(e, t) {
	return Array.isArray(e) ? e.length : e ? Array.from(e).length : bt.count(t);
}
function cr({ size: e = "default", renderEmptyState: t, ...r }) {
	let i = F(null), a = sr(r.items, r.children) > 50;
	Zn(i, a);
	let o = /* @__PURE__ */ A(me, {
		...r,
		ref: i,
		renderEmptyState: t && (() => /* @__PURE__ */ A("div", {
			className: a ? "flex items-center justify-center px-3 py-4 text-center text-base/5 text-textSecondary select-none forced-colors:text-[GrayText] m-1" : "flex items-center justify-center px-3 py-4 text-center text-base/5 text-textSecondary select-none forced-colors:text-[GrayText]",
			children: t()
		})),
		className: U(r.className, n(`${Hn} flex flex-col min-w-32`, a && "block p-0 contain-inline-size"))
	});
	return /* @__PURE__ */ A(or.Provider, {
		value: e,
		children: a ? /* @__PURE__ */ A(_t, {
			layout: ar,
			layoutOptions: e === "touch" ? Wn : Un,
			children: o
		}) : o
	});
}
function lr({ variant: e = "default", iconStart: t, textEnd: n, ...r }) {
	let i = N(or);
	return /* @__PURE__ */ A(he, {
		textValue: r.textValue || (typeof r.children == "string" ? r.children : void 0),
		...r,
		className: O(r.className, (t, { isHovered: n, isFocused: r, isOpen: a, isDisabled: o }) => Gn({
			size: i,
			variant: e,
			isHighlighted: n || r || a,
			isDisabled: o
		}).row({ className: t })),
		children: O(r.children, (r, { selectionMode: i, isSelected: a, hasSubmenu: o }) => /* @__PURE__ */ A(Kn, {
			iconStart: t,
			shortcut: n,
			hasSubmenu: o,
			isSelected: a,
			selectionMode: i,
			variant: e,
			children: r
		}))
	});
}
function ur(e) {
	return /* @__PURE__ */ A(ze, {
		...e,
		className: "box-content h-px w-full shrink-0 border-0 bg-borderPrimary bg-clip-content py-1"
	});
}
function dr(e) {
	return /* @__PURE__ */ j(ge, {
		...e,
		className: "flex flex-col",
		children: [e.title && /* @__PURE__ */ A($n, { children: e.title }), /* @__PURE__ */ A(y, {
			items: e.items,
			children: e.children
		})]
	});
}
function fr(e) {
	let [t, n] = bt.toArray(e.children);
	return /* @__PURE__ */ j(_e, {
		...e,
		children: [t, /* @__PURE__ */ A(ir, {
			placement: e.placement,
			children: n
		})]
	});
}
function pr(e) {
	return /* @__PURE__ */ A(o, { ...e });
}
function mr(e) {
	let [t, n] = bt.toArray(e.children);
	return /* @__PURE__ */ j(Be, {
		...e,
		children: [t, /* @__PURE__ */ A(ir, {
			offset: 0,
			crossOffset: -4,
			children: n
		})]
	});
}
//#endregion
//#region src/lib/components/Field/components/Description.tsx
function G(e) {
	return /* @__PURE__ */ A(tt, {
		...e,
		slot: "description",
		className: M("contain-inline-size text-sm text-textSecondary wrap-break-word transition group-disabled:opacity-disabled forced-colors:group-disabled:text-[GrayText]", e.className)
	});
}
//#endregion
//#region src/lib/components/Field/helpers/fieldStyles.ts
var hr = "outline-1 -outline-offset-1 outline-borderPrimary forced-colors:outline-[ButtonBorder]", gr = "outline-2 -outline-offset-2 outline-brandPrimary forced-colors:outline-[Highlight]", _r = "-my-1.5 -me-3", vr = "size-6 rounded-md -ms-1 last:-me-1.5 hover:bg-backgroundMuted hover:text-textSecondary pressed:bg-backgroundMutedHover pressed:text-textPrimary", yr = r({
	base: "box-border rounded-md bg-backgroundField outline transition forced-colors:bg-[Field]",
	variants: {
		isFocusWithin: {
			false: hr,
			true: gr
		},
		isInvalid: { true: "outline-1 -outline-offset-1 outline-borderDangerPrimary forced-colors:outline-[Mark]" },
		isDisabled: { true: "outline-1 -outline-offset-1 outline-borderPrimary forced-colors:outline-[GrayText]" }
	},
	compoundVariants: [{
		isInvalid: !0,
		isFocusWithin: !0,
		className: "outline-2 -outline-offset-2 outline-borderDangerPrimary forced-colors:outline-[Mark]"
	}]
}), br = r({
	extend: yr,
	base: "group flex items-center gap-2 px-3 py-1.5 overflow-hidden text-base/6",
	compoundVariants: [{
		isDisabled: !0,
		className: B
	}]
}), xr = r({
	base: `${z} inline-flex shrink-0 self-stretch cursor-pointer items-center gap-1.5 border-0 bg-backgroundMuted px-3 text-sm font-medium text-textPrimary transition hover:bg-backgroundMutedHover ${_r}`,
	variants: { isDisabled: { true: B } }
});
function Sr({ affix: t, ...n }) {
	return /* @__PURE__ */ j(o, {
		...n,
		"aria-label": t["aria-label"] ?? t.label,
		isDisabled: t.isDisabled,
		onPress: t.onPress,
		className: O(n.className, (e, t) => xr({
			...t,
			className: e
		})),
		children: [t.icon && /* @__PURE__ */ A(e, {
			name: t.icon,
			size: "sm",
			"aria-hidden": !0
		}), t.label]
	});
}
//#endregion
//#region src/lib/components/Field/components/FieldButton.tsx
var Cr = r({
	base: `${z} relative inline-flex shrink-0 cursor-pointer items-center justify-center rounded-sm border-0 bg-transparent p-0 text-textSecondary transition hover:text-textPrimary pointer-coarse:after:absolute pointer-coarse:after:-inset-x-1 pointer-coarse:after:-inset-y-3`,
	variants: { isDisabled: { true: B } }
});
function wr({ ref: e, ...t }) {
	return /* @__PURE__ */ A(o, {
		ref: e,
		...t,
		className: O(t.className, (e, t) => Cr({
			...t,
			className: e
		}))
	});
}
//#endregion
//#region src/lib/components/Field/components/FieldError.tsx
function K(e) {
	return /* @__PURE__ */ A(ne, {
		...e,
		className: U(e.className, "contain-inline-size text-sm text-textDangerPrimary forced-colors:text-[Mark]")
	});
}
//#endregion
//#region src/lib/components/Field/helpers/fieldSizing.ts
var Tr = 280, Er = 36, Dr = 64;
function Or(e) {
	return typeof e == "number" ? `${e}px` : e;
}
function q({ isFullWidth: e, width: t }, n = 280) {
	if (e) return { width: "100%" };
	let r = t ?? n;
	return r === null ? {} : { width: Or(r) };
}
function J(e, t = 36) {
	let n = e ?? t;
	return n === null ? {} : { height: Or(n) };
}
function Y(e, t) {
	return typeof e == "function" ? (n) => ({
		...t,
		...e(n)
	}) : {
		...t,
		...e
	};
}
//#endregion
//#region src/lib/components/Field/components/FieldGroup.tsx
function kr({ height: e, ref: t, ...n }) {
	return /* @__PURE__ */ A(ie, {
		ref: t,
		...n,
		style: Y(n.style, J(e)),
		className: O(n.className, (e, t) => br({
			...t,
			className: e
		}))
	});
}
//#endregion
//#region src/lib/components/Field/components/InlineSelect.tsx
var Ar = "sm", jr = r({
	base: `${z} inline-flex shrink-0 cursor-pointer items-center gap-1 rounded-sm border-0 bg-transparent p-0 [font:inherit] text-textSecondary outline-0`,
	variants: { isDisabled: { true: B } }
});
function Mr({ affix: t, align: n = "start", anchorRef: r }) {
	let i = t.options.filter((e) => e.isDisabled).map((e) => e.value);
	return /* @__PURE__ */ j(Fe, {
		"aria-label": t["aria-label"],
		isDisabled: t.isDisabled,
		value: t.value,
		defaultValue: t.defaultValue,
		disabledKeys: i.length ? i : void 0,
		onChange: (e) => t.onChange?.(String(e)),
		className: "shrink-0",
		children: [/* @__PURE__ */ j(o, {
			className: (e) => jr({ ...e }),
			children: [/* @__PURE__ */ A(Le, {
				className: "truncate",
				children: ({ selectedText: e, defaultChildren: n }) => e || t.placeholder || n
			}), /* @__PURE__ */ A(e, {
				name: "chevron-down",
				size: "md",
				"aria-hidden": !0,
				className: "shrink-0"
			})]
		}), /* @__PURE__ */ A(ir, {
			placement: n === "end" ? "bottom end" : "bottom start",
			triggerRef: r,
			children: /* @__PURE__ */ A(Qn, {
				itemCount: t.options.length,
				className: "outline-hidden box-border max-h-[inherit] overflow-auto p-1 scroll-py-1",
				children: t.options.map((t) => /* @__PURE__ */ A(qn, {
					id: t.value,
					textValue: t.label,
					children: t.icon ? /* @__PURE__ */ j("span", {
						className: "flex items-center gap-2",
						children: [/* @__PURE__ */ A(e, {
							name: t.icon,
							size: Ar,
							"aria-hidden": !0
						}), t.label]
					}) : t.label
				}, t.value))
			})
		})]
	});
}
//#endregion
//#region src/lib/components/Field/components/Input.tsx
function Nr({ ref: e, ...t }) {
	return /* @__PURE__ */ A(se, {
		ref: e,
		...t,
		className: U(t.className, "min-w-0 flex-1 border-0 bg-transparent p-0 [font:inherit] text-textPrimary outline-0 placeholder:text-textPlaceholder group-invalid:text-textDangerPrimary disabled:text-textDisabled disabled:placeholder:text-textDisabled")
	});
}
//#endregion
//#region src/lib/components/Field/components/Label.tsx
var Pr = r({ base: "w-fit cursor-default select-none text-base font-medium text-textPrimary transition group-disabled:opacity-disabled forced-colors:group-disabled:text-[GrayText]" });
function X({ children: e, isRequired: t, isRequiredAnnouncedByInput: n, ...r }) {
	return /* @__PURE__ */ j(ce, {
		...r,
		className: Pr({ className: r.className }),
		children: [e, t && /* @__PURE__ */ A("span", {
			"aria-hidden": n,
			className: "text-textDangerPrimary forced-colors:text-[Mark] forced-colors:group-disabled:text-[GrayText]",
			children: "\xA0*"
		})]
	});
}
//#endregion
//#region src/lib/components/Field/helpers/controlFieldStyles.ts
var Fr = {
	sm: "size-3.5",
	md: "size-4"
}, Ir = {
	sm: "h-4 w-7",
	md: "h-5 w-9"
}, Lr = {
	sm: "size-3",
	md: "size-4"
}, Rr = r({
	base: "group grid content-start",
	variants: {
		variant: {
			default: "gap-y-0",
			text: "gap-y-1.5"
		},
		controlPlacement: {
			start: "grid-cols-[auto_1fr]",
			end: ""
		}
	}
}), zr = r({
	base: `group items-start transition ${sn}`,
	variants: {
		size: {
			sm: "",
			md: ""
		},
		controlPlacement: {
			start: "col-span-full grid grid-cols-subgrid",
			end: "flex flex-row-reverse"
		},
		isDisabled: {
			false: "cursor-pointer",
			true: B
		},
		isReadOnly: { true: "cursor-default" }
	},
	compoundVariants: [
		{
			controlPlacement: "end",
			size: "sm",
			className: "gap-2"
		},
		{
			controlPlacement: "end",
			size: "md",
			className: "gap-3"
		},
		{
			isDisabled: !0,
			isReadOnly: !0,
			className: "cursor-not-allowed"
		}
	]
}), Br = r({
	base: "flex shrink-0 items-center justify-center",
	variants: { size: {
		sm: "h-5",
		md: "h-6"
	} }
}), Vr = r({
	base: "block min-w-px py-0.5 empty:hidden",
	variants: {
		size: {
			sm: "text-sm/4",
			md: "text-base/5"
		},
		variant: {
			default: "font-medium text-textPrimary",
			text: "font-normal text-textSecondary"
		},
		controlPlacement: {
			start: "",
			end: "flex-1"
		}
	},
	compoundVariants: [{
		controlPlacement: "start",
		size: "sm",
		className: "ms-2"
	}, {
		controlPlacement: "start",
		size: "md",
		className: "ms-3"
	}]
}), Hr = r({
	variants: {
		size: {
			sm: "",
			md: ""
		},
		controlPlacement: {
			start: "col-start-2",
			end: ""
		}
	},
	compoundVariants: [{
		controlPlacement: "start",
		size: "sm",
		className: "ms-2"
	}, {
		controlPlacement: "start",
		size: "md",
		className: "ms-3"
	}]
}), Ur = r({
	base: `${cn} box-border flex shrink-0 items-center border transition`,
	variants: {
		isSelected: {
			false: "border-borderPrimary bg-backgroundField",
			true: "border-brandPrimary bg-brandPrimary forced-colors:border-[Highlight]! forced-colors:bg-[Highlight]!"
		},
		isInvalid: { true: "" }
	},
	compoundVariants: [{
		isSelected: !1,
		isInvalid: !0,
		className: "border-borderDangerPrimary forced-colors:border-[Mark]!"
	}]
});
//#endregion
//#region src/lib/components/SearchField/DsSearchField.tsx
function Wr({ height: t, isFullWidth: n, width: r, label: i, description: a, errorMessage: o, placeholder: s, ...c }) {
	return /* @__PURE__ */ j(Pe, {
		...c,
		style: Y(c.style, q({
			isFullWidth: n,
			width: r
		})),
		className: U(c.className, "group flex flex-col gap-2 min-w-[40px]"),
		children: [
			i && /* @__PURE__ */ A(X, {
				isRequired: c.isRequired,
				isRequiredAnnouncedByInput: !0,
				children: i
			}),
			/* @__PURE__ */ j(kr, {
				height: t,
				children: [
					/* @__PURE__ */ A(e, {
						name: "search",
						"aria-hidden": !0,
						size: "sm",
						className: "shrink-0 text-textSecondary group-disabled:text-textDisabled forced-colors:text-[ButtonText] forced-colors:group-disabled:text-[GrayText]"
					}),
					/* @__PURE__ */ A(Nr, {
						placeholder: s,
						className: "text-ellipsis [&::-webkit-search-cancel-button]:hidden"
					}),
					/* @__PURE__ */ A(wr, {
						className: `${vr} group-empty:invisible group-disabled:invisible`,
						children: /* @__PURE__ */ A(e, {
							name: "x",
							"aria-hidden": !0,
							size: "sm"
						})
					})
				]
			}),
			a && /* @__PURE__ */ A(G, { children: a }),
			/* @__PURE__ */ A(K, { children: o })
		]
	});
}
//#endregion
//#region src/lib/components/Autocomplete/DsAutocomplete.tsx
function Gr({ filter: e, onInputChange: t, ...n }) {
	let { contains: r } = vt({ sensitivity: "base" }), [i, o] = I(!!n.defaultInputValue), s = n.inputValue === void 0 ? i : n.inputValue !== "";
	return /* @__PURE__ */ A(a, {
		...n,
		filter: e ?? (s ? r : void 0),
		onInputChange: (e) => {
			o(e !== ""), t?.(e);
		}
	});
}
function Kr(e) {
	let { t } = V();
	return /* @__PURE__ */ A("div", {
		className: "flex flex-col max-h-[inherit]",
		children: /* @__PURE__ */ j(Gr, {
			...e,
			children: [/* @__PURE__ */ A("div", {
				className: "px-1 pt-1",
				children: /* @__PURE__ */ A(Wr, {
					isFullWidth: !0,
					autoFocus: !0,
					"aria-label": e["aria-label"],
					placeholder: e.placeholder
				})
			}), /* @__PURE__ */ A(cr, {
				...e,
				style: { flex: 1 },
				renderEmptyState: () => t("autocomplete.noResults"),
				children: (e) => /* @__PURE__ */ A(lr, { ...e })
			})]
		})
	});
}
//#endregion
//#region src/lib/components/Avatar/DsAvatar.tsx
var qr = [
	"brand",
	"info",
	"success",
	"warning",
	"danger"
];
function Jr(e) {
	let t = 0;
	for (let n = 0; n < e.length; n += 1) t = t * 31 + e.charCodeAt(n) | 0;
	return qr[Math.abs(t) % qr.length];
}
var Yr = St(null), Xr = r({
	base: [
		"relative inline-flex shrink-0 items-center justify-center align-middle",
		"font-medium select-none",
		"outline-1 -outline-offset-1 outline-borderPrimary"
	],
	variants: {
		variant: {
			neutral: "bg-backgroundMuted text-textPrimary",
			brand: "bg-brandPrimaryMuted text-textBrandHover",
			brandSolid: "bg-brandPrimary text-textOnBrandPrimary",
			success: "bg-backgroundSuccessPrimary text-textSuccessPrimary",
			danger: "bg-backgroundDangerPrimary text-textDangerPrimary",
			warning: "bg-backgroundWarningPrimary text-textWarningPrimary",
			info: "bg-backgroundInfoPrimary text-textInfoPrimary"
		},
		size: {
			xs: "size-6 text-sm",
			sm: "size-8 text-base",
			md: "size-10 text-lg",
			lg: "size-12 text-xl",
			xl: "size-14 text-xl"
		},
		shape: {
			pill: "rounded-full",
			square: "rounded-md"
		},
		isStacked: { true: "ring-2 ring-backgroundRaised" }
	},
	defaultVariants: {
		variant: "neutral",
		size: "md",
		shape: "pill"
	}
}), Zr = r({
	base: ["absolute block rounded-full", "ring-2 ring-backgroundRaised"],
	variants: {
		status: {
			online: "bg-textSuccessTertiary",
			offline: "bg-textTertiary",
			busy: "bg-textDangerTertiary",
			away: "bg-textWarningTertiary"
		},
		size: {
			xs: "size-1.5",
			sm: "size-2",
			md: "size-2.5",
			lg: "size-3",
			xl: "size-3.5"
		},
		statusPlacement: {
			top: "top-0 end-0",
			bottom: "bottom-0 end-0"
		},
		shape: {
			pill: "",
			square: "translate-x-1/2 rtl:-translate-x-1/2"
		}
	},
	compoundVariants: [{
		shape: "square",
		statusPlacement: "top",
		class: "-translate-y-1/2"
	}, {
		shape: "square",
		statusPlacement: "bottom",
		class: "translate-y-1/2"
	}],
	defaultVariants: {
		status: "offline",
		size: "md",
		statusPlacement: "bottom",
		shape: "pill"
	}
}), Qr = r({
	base: "flex items-center",
	variants: {
		size: {
			xs: "-space-x-1",
			sm: "-space-x-2",
			md: "-space-x-2",
			lg: "-space-x-2.5",
			xl: "-space-x-3"
		},
		stacking: {
			start: "isolate",
			end: ""
		}
	},
	defaultVariants: {
		size: "md",
		stacking: "end"
	}
});
function $r() {
	return /* @__PURE__ */ A("svg", {
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": !0,
		className: "size-full overflow-hidden rounded-[inherit] opacity-70",
		children: /* @__PURE__ */ A("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" })
	});
}
var ei = ({ src: t, alt: r, initials: i, icon: a, variant: o = "neutral", size: s, shape: c, status: l, statusPlacement: u = "bottom", statusLabel: d, className: f, ...p }) => {
	let m = N(Yr), [h, g] = I(), _ = s ?? m?.size ?? "md", v = c ?? m?.shape ?? "pill", y = !!t && h !== t, b = y ? void 0 : [r, d].filter(Boolean).join(", ") || void 0, x = y ? d : void 0, S = () => y ? /* @__PURE__ */ A("img", {
		src: t,
		alt: r ?? "",
		onError: () => g(t),
		className: "size-full rounded-[inherit] object-cover"
	}) : i ? /* @__PURE__ */ A("span", {
		className: "max-w-full overflow-hidden",
		children: i
	}) : a ? /* @__PURE__ */ A(e, {
		name: a,
		size: _,
		className: "opacity-70"
	}) : /* @__PURE__ */ A($r, {});
	return /* @__PURE__ */ j("span", {
		role: b ? "img" : void 0,
		"aria-label": b,
		className: n(Xr({
			variant: o,
			size: _,
			shape: v,
			isStacked: m !== null
		}), f),
		...p,
		children: [S(), l && /* @__PURE__ */ A("span", {
			role: x ? "img" : void 0,
			"aria-label": x,
			className: Zr({
				status: l,
				size: _,
				statusPlacement: u,
				shape: v
			})
		})]
	});
}, ti = ({ size: e = "md", shape: t = "pill", stacking: r = "end", children: i, className: a, ...o }) => {
	let s = Ot(() => ({
		size: e,
		shape: t
	}), [e, t]), c = bt.toArray(i);
	return /* @__PURE__ */ A(Yr.Provider, {
		value: s,
		children: /* @__PURE__ */ A("div", {
			className: n(Qr({
				size: e,
				stacking: r
			}), a),
			...o,
			children: c.map((e, t) => /* @__PURE__ */ A("span", {
				className: "relative shrink-0",
				style: r === "start" ? { zIndex: c.length - t } : void 0,
				children: e
			}, wt(e) ? e.key ?? t : t))
		})
	});
}, ni = r({
	base: "inline-flex align-top items-center justify-center gap-1 inset-ring-1 font-medium whitespace-nowrap",
	variants: {
		variant: {
			neutral: "bg-backgroundMuted inset-ring-borderPrimary text-textSecondary",
			brand: "bg-brandPrimaryMuted inset-ring-brandPrimary text-textBrandHover",
			success: "bg-backgroundSuccessPrimary inset-ring-borderSuccessPrimary text-textSuccessPrimary",
			danger: "bg-backgroundDangerPrimary inset-ring-borderDangerPrimary text-textDangerPrimary",
			warning: "bg-backgroundWarningPrimary inset-ring-borderWarningPrimary text-textWarningPrimary",
			info: "bg-backgroundInfoPrimary inset-ring-borderInfoPrimary text-textInfoPrimary"
		},
		size: {
			sm: "px-1.5 py-0.5 text-sm/4",
			md: "px-2 py-1 text-sm/4"
		},
		shape: {
			pill: "rounded-full",
			square: "rounded-md"
		}
	},
	defaultVariants: {
		variant: "neutral",
		size: "md",
		shape: "pill"
	}
}), ri = ({ variant: e, size: t, shape: r, showDot: i, onRemove: a, removeLabel: o, children: s, className: c, ...l }) => {
	let { t: u } = V();
	return /* @__PURE__ */ j("span", {
		className: n(ni({
			variant: e,
			size: t,
			shape: r
		}), c),
		...l,
		children: [
			i && /* @__PURE__ */ A("span", { className: n("size-1.5 shrink-0 rounded-full bg-current", e === "brand" && "bg-brandPrimaryHover") }),
			s,
			a && /* @__PURE__ */ A(Fn, {
				"aria-label": o ?? u("common.remove"),
				size: "sm",
				name: "x",
				variant: "plain",
				onPress: a,
				className: "shrink-0 p-0"
			})
		]
	});
}, ii = "sm", ai = 16, oi = {
	primary: "var(--textBrand)",
	secondary: "var(--textSecondary)"
}, si = r({
	base: `${z} relative inline-flex items-center gap-1.5 p-0 text-base font-medium whitespace-nowrap rounded-xs transition cursor-pointer ${on}`,
	variants: {
		variant: {
			primary: "text-textBrand hover:text-textBrandHover pressed:text-textBrandActive",
			secondary: "text-textSecondary hover:text-textPrimary pressed:text-textPrimary"
		},
		isDisabled: { true: B },
		isPending: { true: "text-transparent" }
	},
	defaultVariants: { variant: "primary" }
});
function ci({ variant: t = "primary", iconStart: n, iconEnd: r, ...i }) {
	return /* @__PURE__ */ A(o, {
		...i,
		className: O(i.className, (e, n) => si({
			...n,
			variant: t,
			className: e
		})),
		children: O(i.children, (i, { isPending: a }) => /* @__PURE__ */ j(k, { children: [
			n && /* @__PURE__ */ A(e, {
				name: n,
				size: ii,
				"aria-hidden": !0
			}),
			i,
			r && /* @__PURE__ */ A(e, {
				name: r,
				size: ii,
				"aria-hidden": !0
			}),
			a && /* @__PURE__ */ A("span", {
				"aria-hidden": !0,
				className: "flex absolute inset-0 justify-center items-center",
				children: /* @__PURE__ */ A(gn, {
					size: ai,
					stroke: oi[t]
				})
			})
		] }))
	});
}
function li(e) {
	return /* @__PURE__ */ j("svg", {
		width: 20,
		height: 20,
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		"aria-hidden": !0,
		...e,
		children: [
			/* @__PURE__ */ A("path", {
				d: "M19.6 10.2273C19.6 9.5182 19.5364 8.8364 19.4182 8.1818H10V12.05H15.3818C15.15 13.3 14.4455 14.3591 13.3864 15.0682V17.5773H16.6182C18.5091 15.8364 19.6 13.2727 19.6 10.2273Z",
				fill: "#4285F4"
			}),
			/* @__PURE__ */ A("path", {
				d: "M10.0001 20C12.7001 20 14.9637 19.1045 16.6182 17.5773L13.3864 15.0682C12.491 15.6682 11.3455 16.0227 10.0001 16.0227C7.39552 16.0227 5.19102 14.2636 4.40462 11.9H1.06372V14.4909C2.70922 17.7591 6.09102 20 10.0001 20Z",
				fill: "#34A853"
			}),
			/* @__PURE__ */ A("path", {
				d: "M4.4045 11.9C4.2045 11.3 4.0909 10.6591 4.0909 10C4.0909 9.3409 4.2045 8.7 4.4045 8.1V5.5091H1.0636C0.3864 6.8591 0 8.3864 0 10C0 11.6136 0.3864 13.1409 1.0636 14.4909L4.4045 11.9Z",
				fill: "#FBBC04"
			}),
			/* @__PURE__ */ A("path", {
				d: "M10.0001 3.9773C11.4682 3.9773 12.7864 4.4818 13.8228 5.4727L16.691 2.6045C14.9592 0.9909 12.6955 0 10.0001 0C6.09102 0 2.70922 2.2409 1.06372 5.5091L4.40462 8.1C5.19102 5.7364 7.39552 3.9773 10.0001 3.9773Z",
				fill: "#E94235"
			})
		]
	});
}
function ui(e) {
	return /* @__PURE__ */ A("svg", {
		width: 20,
		height: 20,
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		"aria-hidden": !0,
		...e,
		children: /* @__PURE__ */ A("path", {
			d: "M15.8093 14.874C15.0931 15.9279 14.3338 16.9564 13.1776 16.9734C12.0215 16.9989 11.6504 16.3019 10.3389 16.3019C9.0188 16.3019 8.61326 16.9564 7.51744 16.9989C6.38713 17.0414 5.53292 15.8769 4.80814 14.8485C3.3327 12.7492 2.20239 8.88191 3.72097 6.28108C4.47164 4.98917 5.81766 4.17322 7.27585 4.14772C8.3803 4.13073 9.43295 4.88718 10.1146 4.88718C10.7876 4.88718 12.0646 3.97774 13.402 4.11373C13.9628 4.13923 15.5332 4.33471 16.5427 5.79661C16.465 5.84761 14.6704 6.88454 14.6876 9.0349C14.7135 11.6017 16.9741 12.4602 17 12.4687C16.9741 12.5282 16.6376 13.6926 15.8093 14.874ZM10.8825 1.27492C11.5124 0.569462 12.5564 0.0339977 13.4192 0C13.5314 0.994434 13.1259 1.99737 12.5219 2.71132C11.9265 3.43377 10.9429 3.99473 9.97654 3.91824C9.84711 2.9408 10.3303 1.92087 10.8825 1.27492Z",
			fill: "currentColor"
		})
	});
}
//#endregion
//#region src/lib/components/Button/SocialButton/DsSocialButton.tsx
var di = {
	google: "socialButton.continueWith.google",
	apple: "socialButton.continueWith.apple",
	sso: "socialButton.continueWith.sso"
}, fi = {
	google: /* @__PURE__ */ A(li, {}),
	apple: /* @__PURE__ */ A(ui, {}),
	sso: /* @__PURE__ */ A(e, {
		name: "key-round",
		size: "md",
		className: "text-textTertiary",
		"aria-hidden": !0
	})
};
function pi({ provider: e, className: t, children: n, ...r }) {
	let { t: i } = V();
	return /* @__PURE__ */ A(H, {
		...r,
		variant: "secondary",
		size: "lg",
		className: U(t, "gap-3 min-w-0 w-full"),
		children: O(n, (t, { isPending: n }) => /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A("span", {
			"aria-hidden": !0,
			className: M("flex shrink-0", n && "opacity-0"),
			children: fi[e]
		}), t ?? i(di[e])] }))
	});
}
//#endregion
//#region src/lib/components/Heading/DsHeading.tsx
var mi = r({
	base: "font-semibold text-balance text-textPrimary",
	variants: { size: {
		"2xs": "text-xl tracking-tight",
		xs: "text-2xl",
		sm: "text-3xl",
		md: "text-4xl",
		lg: "text-5xl"
	} },
	defaultVariants: { size: "md" }
});
function hi({ ref: e, size: t, ...n }) {
	return /* @__PURE__ */ A(oe, {
		ref: e,
		...n,
		className: mi({
			size: t,
			className: n.className
		})
	});
}
//#endregion
//#region src/lib/components/Card/DsCard.tsx
var gi = r({
	base: `flex min-w-0 flex-col [--card-padding:--spacing(4)] sm:[--card-padding:--spacing(6)] ${rn}`,
	variants: { padding: {
		default: "gap-(--card-padding) p-(--card-padding)",
		compact: "gap-4 p-4",
		none: "overflow-clip"
	} },
	defaultVariants: { padding: "default" }
}), _i = r({
	base: "flex min-h-8 flex-wrap items-center gap-x-4 gap-y-3",
	variants: { padding: {
		default: "",
		compact: "",
		none: "px-(--card-padding) pt-(--card-padding)"
	} }
});
function vi({ title: e, description: t, action: n, titleLevel: r = 2, padding: i = "default", ref: a, className: o, children: s, ...c }) {
	let l = Et(), u = Et(), d = e !== void 0, f = d && c["aria-label"] === void 0;
	return /* @__PURE__ */ j("section", {
		...c,
		ref: a,
		"aria-labelledby": c["aria-labelledby"] ?? (f ? l : void 0),
		"aria-describedby": c["aria-describedby"] ?? (t ? u : void 0),
		className: gi({
			padding: i,
			className: o
		}),
		children: [d && /* @__PURE__ */ j("div", {
			className: _i({ padding: i }),
			children: [/* @__PURE__ */ j("div", {
				className: "flex min-w-0 flex-auto flex-col gap-1",
				children: [/* @__PURE__ */ A(hi, {
					id: l,
					level: r,
					size: "2xs",
					children: e
				}), t && /* @__PURE__ */ A("p", {
					id: u,
					className: "text-base text-textSecondary",
					children: t
				})]
			}), !!n && /* @__PURE__ */ A("div", {
				className: "ms-auto flex shrink-0 items-center gap-2",
				children: n
			})]
		}), s]
	});
}
//#endregion
//#region src/lib/components/Checkbox/DsCheckbox.tsx
var yi = r({
	extend: Ur,
	base: "justify-center rounded-xs",
	variants: { size: {
		sm: Fr.sm,
		md: Fr.md
	} }
}), bi = "pointer-events-none text-textOnBrandPrimary forced-colors:text-[HighlightText]";
function xi({ children: t, className: n, controlPlacement: r = "start", description: i, errorMessage: a, size: o = "md", variant: s = "default", ...c }) {
	let l = Hr({
		controlPlacement: r,
		size: o
	});
	return /* @__PURE__ */ j(_, {
		...c,
		className: Rr({
			controlPlacement: r,
			variant: s
		}),
		children: [
			/* @__PURE__ */ A(g, {
				className: O(n, (e, t) => zr({
					...t,
					controlPlacement: r,
					size: o,
					className: e
				})),
				children: O(t, (t, { isIndeterminate: n, isSelected: i, ...a }) => /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A("span", {
					className: Br({ size: o }),
					children: /* @__PURE__ */ A("span", {
						className: yi({
							...a,
							isSelected: i || n,
							size: o
						}),
						children: (i || n) && /* @__PURE__ */ A(e, {
							name: n ? "minus" : "check",
							size: "sm",
							strokeWidth: 1.75,
							className: bi
						})
					})
				}), /* @__PURE__ */ A("span", {
					className: Vr({
						controlPlacement: r,
						size: o,
						variant: s
					}),
					children: t
				})] }))
			}),
			i && /* @__PURE__ */ A(G, {
				className: l,
				children: i
			}),
			/* @__PURE__ */ A(K, {
				className: l,
				children: a
			})
		]
	});
}
//#endregion
//#region src/lib/components/CheckboxGroup/DsCheckboxGroup.tsx
function Si({ children: e, description: t, errorMessage: n, label: r, ...i }) {
	return /* @__PURE__ */ A(v, {
		...i,
		className: U(i.className, "group flex flex-col gap-2"),
		children: ({ isRequired: i }) => /* @__PURE__ */ j(k, { children: [
			r && /* @__PURE__ */ A(X, {
				isRequired: i,
				isRequiredAnnouncedByInput: !0,
				children: r
			}),
			/* @__PURE__ */ A("div", {
				className: "flex flex-col gap-3",
				children: e
			}),
			t && /* @__PURE__ */ A(G, { children: t }),
			/* @__PURE__ */ A(K, { children: n })
		] })
	});
}
//#endregion
//#region src/lib/components/Chip/helpers/chipStyles.ts
var Ci = `${z} relative inline-flex items-center py-1.5 rounded-full text-base font-medium whitespace-nowrap cursor-pointer transition ${on} bg-backgroundMuted`, wi = r({
	base: `${Ci} max-w-full gap-1 ps-3 pe-2`,
	variants: { isHovered: { true: "bg-backgroundMutedHover" } }
});
function Ti({ items: e, children: t, onRemove: n, ...r }) {
	return /* @__PURE__ */ A($e, {
		...r,
		onAction: n,
		onRemove: (e) => e.forEach((e) => n(e)),
		children: /* @__PURE__ */ A(et, {
			items: e,
			className: "flex flex-wrap gap-2",
			children: t
		})
	});
}
function Ei({ field: t, children: n, ...r }) {
	return /* @__PURE__ */ j(Qe, {
		...r,
		textValue: `${t}: ${n}`,
		className: O(r.className, (e, t) => wi({
			...t,
			className: e
		})),
		children: [
			/* @__PURE__ */ j("span", {
				className: "shrink-0 text-textSecondary",
				children: [t, ":"]
			}),
			/* @__PURE__ */ A("span", {
				className: "min-w-0 truncate text-textPrimary",
				children: n
			}),
			/* @__PURE__ */ A(o, {
				slot: "remove",
				excludeFromTabOrder: !0,
				preventFocusOnPress: !0,
				className: `${z} flex shrink-0 rounded-full text-textPrimary`,
				children: /* @__PURE__ */ A(e, {
					name: "x",
					size: "sm",
					"aria-hidden": !0
				})
			})
		]
	});
}
//#endregion
//#region src/lib/components/Chip/DsChip.tsx
var Di = r({
	base: `${Ci} px-3 text-textSecondary`,
	variants: {
		isHovered: { true: "bg-backgroundMutedHover text-textPrimary" },
		isSelected: { true: "bg-backgroundInverse text-textOnInverse forced-colors:bg-[Highlight]! forced-colors:text-[HighlightText]" },
		isDisabled: { true: `${B} forced-colors:text-[GrayText]` },
		isReadOnly: { true: "cursor-default" }
	}
});
function Oi({ children: e, isDisabled: t, isReadOnly: n, ...r }) {
	return /* @__PURE__ */ A(at, {
		...r,
		isDisabled: t || n,
		"data-readonly": n || void 0,
		className: O(r.className, (e, r) => Di({
			...r,
			isDisabled: t || r.isDisabled && !n,
			isReadOnly: n,
			className: e
		})),
		children: e
	});
}
function ki(e) {
	return /* @__PURE__ */ A(ot, {
		...e,
		className: U(e.className, "flex flex-wrap gap-2")
	});
}
//#endregion
//#region src/lib/components/DatePicker/shared/styles.ts
var Ai = "flex flex-1 items-center min-w-0 overflow-x-auto whitespace-nowrap [scrollbar-width:none] [&::-webkit-scrollbar]:hidden", ji = `${W({ level: "panel" }).surface({ class: "rounded-md" })} ${un} overflow-y-auto p-3 flex flex-col gap-4`;
function Mi(e) {
	return 224 * e + 49 * (e - 1) + 24;
}
var Ni = "border-separate border-spacing-x-0 border-spacing-y-2 -my-2", Pi = "w-8 h-5 text-center text-sm text-textTertiary font-normal", Fi = [
	"relative inline-flex size-8 items-center justify-center rounded-md",
	"text-sm text-textPrimary",
	"outline-none transition-colors",
	"cursor-pointer",
	"hover:bg-backgroundHover"
], Ii = [
	"data-[disabled]:text-textDisabled data-[disabled]:cursor-not-allowed data-[disabled]:pointer-events-none",
	"data-[unavailable]:text-textDisabled data-[unavailable]:cursor-not-allowed data-[unavailable]:pointer-events-none",
	"data-[outside-month]:hidden"
], Li = ["data-[selected]:text-textOnBrandPrimary", "text-[var(--ds-datepicker-accent,var(--textBrand))]"], Ri = [
	"data-[selected]:bg-[var(--ds-datepicker-accent,var(--brandPrimary))]",
	"data-[selected]:text-[var(--ds-datepicker-accent-foreground,var(--textOnBrandPrimary))]",
	"data-[selected]:hover:bg-[var(--ds-datepicker-accent,var(--brandPrimary))]",
	"data-[selected]:hover:text-[var(--ds-datepicker-accent-foreground,var(--textOnBrandPrimary))]"
], zi = [
	"data-[selected]:bg-brandPrimaryMuted",
	"data-[selected]:text-textPrimary",
	"data-[selected]:rounded-none",
	"data-[selected]:hover:bg-brandPrimaryMuted"
], Bi = [
	"data-[selection-start]:bg-[var(--ds-datepicker-accent,var(--brandPrimary))]!",
	"data-[selection-start]:text-[var(--ds-datepicker-accent-foreground,var(--textOnBrandPrimary))]!",
	"data-[selection-start]:rounded-s-md!",
	"data-[selection-start]:rounded-e-none!",
	"data-[selection-end]:bg-[var(--ds-datepicker-accent,var(--brandPrimary))]!",
	"data-[selection-end]:text-[var(--ds-datepicker-accent-foreground,var(--textOnBrandPrimary))]!",
	"data-[selection-end]:rounded-e-md!",
	"data-[selection-end]:rounded-s-none!",
	"data-[selection-start]:data-[selection-end]:rounded-md!"
], Vi = "inline-flex size-8 items-center justify-center rounded-md border border-borderSurface text-sm text-textPrimary tabular-nums whitespace-pre outline-none focus-within:border-brandPrimary", Hi = "flex items-center gap-3 w-full";
//#endregion
//#region src/lib/components/DatePicker/shared/components/PickerFooter.tsx
function Ui({ onApply: e, onCancel: t, isApplyDisabled: n }) {
	let { t: r } = V(), i = N(w), a = N(ee), o = () => (i ?? a)?.setOpen(!1);
	return /* @__PURE__ */ j("div", {
		className: Hi,
		children: [/* @__PURE__ */ A(H, {
			variant: "secondary",
			size: "lg",
			className: "flex-1",
			onPress: () => {
				t(), o();
			},
			children: r("common.cancel")
		}), /* @__PURE__ */ A(H, {
			variant: "primary",
			size: "lg",
			isDisabled: n,
			className: "flex-1",
			onPress: () => {
				e(), o();
			},
			children: r("common.apply")
		})]
	});
}
//#endregion
//#region src/lib/components/DatePicker/shared/components/FieldSegment.tsx
var Wi = {
	day: R("dateField.placeholder.day"),
	month: R("dateField.placeholder.month"),
	year: R("dateField.placeholder.year"),
	hour: R("timeField.placeholder.hours"),
	minute: R("timeField.placeholder.minutes"),
	second: R("timeField.placeholder.seconds")
};
function Gi({ segment: e }) {
	let { t } = V(), n = Wi[e.type];
	return /* @__PURE__ */ A(E, {
		segment: e,
		className: "tabular-nums whitespace-pre outline-none rounded-sm data-[placeholder]:text-textPlaceholder data-[type=literal]:text-textTertiary data-[focused]:bg-brandPrimaryMuted data-[focused]:text-textPrimary",
		children: (e) => {
			if (!e.isPlaceholder || !n) return e.text;
			let r = t(n);
			return r && r !== n ? r : e.text;
		}
	});
}
//#endregion
//#region src/lib/components/DatePicker/shared/components/PickerTriggerField.tsx
function Ki({ variant: t, displayText: r, height: i, isPlaceholder: a, segmentSlots: o }) {
	let { t: s } = V(), c = N(w), l = N(ee), u = c ?? l, d = F(null);
	return /* @__PURE__ */ j(ie, {
		onClick: (e) => {
			let t = e.target;
			e.currentTarget.hasAttribute("data-disabled") || t.closest("[role=\"spinbutton\"]") || d.current?.contains(t) || u?.setOpen(!0);
		},
		style: Y(void 0, J(i)),
		className: (e) => br({
			...e,
			isFocusWithin: e.isFocusWithin || !!u?.isOpen,
			className: e.isDisabled ? "text-textPrimary" : "cursor-pointer text-textPrimary"
		}),
		children: [t === "display" ? /* @__PURE__ */ A("span", {
			className: n(Ai, a && "text-textPlaceholder"),
			children: r
		}) : o ? /* @__PURE__ */ j("div", {
			className: Ai,
			children: [
				/* @__PURE__ */ A(S, {
					slot: "start",
					children: (e) => /* @__PURE__ */ A(Gi, { segment: e })
				}),
				/* @__PURE__ */ A("span", {
					"aria-hidden": "true",
					className: "mx-2 text-textTertiary select-none",
					children: "—"
				}),
				/* @__PURE__ */ A(S, {
					slot: "end",
					children: (e) => /* @__PURE__ */ A(Gi, { segment: e })
				})
			]
		}) : /* @__PURE__ */ A(S, {
			className: Ai,
			children: (e) => /* @__PURE__ */ A(Gi, { segment: e })
		}), /* @__PURE__ */ A(wr, {
			ref: d,
			"aria-label": s("calendar.aria.openCalendar"),
			children: /* @__PURE__ */ A(e, {
				name: "calendar",
				size: "md",
				"aria-hidden": !0
			})
		})]
	});
}
//#endregion
//#region src/lib/components/DatePicker/shared/utils/calendarI18n.ts
var qi = [
	"",
	R("calendar.months.january"),
	R("calendar.months.february"),
	R("calendar.months.march"),
	R("calendar.months.april"),
	R("calendar.months.may"),
	R("calendar.months.june"),
	R("calendar.months.july"),
	R("calendar.months.august"),
	R("calendar.months.september"),
	R("calendar.months.october"),
	R("calendar.months.november"),
	R("calendar.months.december")
], Ji = [
	R("calendar.weekdays.sun"),
	R("calendar.weekdays.mon"),
	R("calendar.weekdays.tue"),
	R("calendar.weekdays.wed"),
	R("calendar.weekdays.thu"),
	R("calendar.weekdays.fri"),
	R("calendar.weekdays.sat")
];
function Yi(e, t) {
	return t(qi[e]);
}
function Xi(e, t) {
	let n = [
		"sun",
		"mon",
		"tue",
		"wed",
		"thu",
		"fri",
		"sat"
	], r = 0;
	try {
		let t = new Intl.Locale(e).getWeekInfo();
		r = t.firstDay === 7 ? 0 : t.firstDay;
	} catch {
		r = 0;
	}
	return n.map((e, n) => t(Ji[(r + n) % 7]));
}
//#endregion
//#region src/lib/components/DatePicker/shared/components/CalendarHeader.tsx
var Zi = [
	"relative inline-flex size-5 items-center justify-center rounded-md",
	"pointer-coarse:after:absolute pointer-coarse:after:-inset-x-0.5 pointer-coarse:after:-inset-y-3",
	"text-textSecondary outline-none transition-colors cursor-pointer",
	"hover:text-textPrimary",
	"focus-visible:ring-2 focus-visible:ring-brandPrimary focus-visible:ring-offset-0",
	"disabled:opacity-disabled disabled:pointer-events-none disabled:cursor-not-allowed"
], Qi = "flex-1 text-center text-base font-medium text-textPrimary whitespace-nowrap";
function $i({ showYearChevrons: t = !0, monthsToShow: r = 1 }) {
	let { t: i } = V(), a = N(m), s = N(Ae), c = a ?? s;
	if (!c) return null;
	let l = c.visibleRange?.start ?? c.focusedDate, u = Array.from({ length: r }, (e, t) => {
		let n = l.add({ months: t });
		return `${Yi(n.month, i)} ${n.year}`;
	}), d = () => c.setFocusedDate(l.subtract({ years: 1 })), f = () => c.setFocusedDate(l.add({ years: 1 })), p = l.subtract({ years: 1 }).add({ months: 1 }).subtract({ days: 1 }), h = l.add({ years: 1 }), g = c.minValue !== null && c.minValue !== void 0 && p.compare(c.minValue) < 0, _ = c.maxValue !== null && c.maxValue !== void 0 && h.compare(c.maxValue) > 0;
	return /* @__PURE__ */ j("div", {
		className: "flex items-center gap-1 w-full",
		children: [
			t && /* @__PURE__ */ A("button", {
				type: "button",
				onClick: d,
				disabled: g,
				"aria-label": i("calendar.aria.prevYear"),
				className: n(...Zi),
				children: /* @__PURE__ */ A(e, {
					name: "chevrons-left",
					size: "sm",
					className: "rtl:-scale-x-100"
				})
			}),
			/* @__PURE__ */ A(o, {
				slot: "previous",
				className: n(...Zi),
				children: /* @__PURE__ */ A(e, {
					name: "chevron-left",
					size: "md",
					className: "rtl:-scale-x-100"
				})
			}),
			u.map((e, t) => /* @__PURE__ */ A("span", {
				className: Qi,
				children: e
			}, t)),
			/* @__PURE__ */ A(o, {
				slot: "next",
				className: n(...Zi),
				children: /* @__PURE__ */ A(e, {
					name: "chevron-right",
					size: "md",
					className: "rtl:-scale-x-100"
				})
			}),
			t && /* @__PURE__ */ A("button", {
				type: "button",
				onClick: f,
				disabled: _,
				"aria-label": i("calendar.aria.nextYear"),
				className: n(...Zi),
				children: /* @__PURE__ */ A(e, {
					name: "chevrons-right",
					size: "sm",
					className: "rtl:-scale-x-100"
				})
			})
		]
	});
}
//#endregion
//#region src/lib/components/DatePicker/shared/components/RangeCalendarMonths.tsx
var ea = [
	...Fi,
	...zi,
	...Bi,
	...Ii
];
function ta({ numOfMonths: e, showYearChevrons: t = !0 }) {
	let { locale: r } = It(), { t: i } = V(), a = Xi(r, i), o = 0;
	return /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A($i, {
		showYearChevrons: t,
		monthsToShow: e
	}), /* @__PURE__ */ A("div", {
		className: n("flex items-start gap-6", e === 1 && "block"),
		children: Array.from({ length: e }, (e, t) => /* @__PURE__ */ j(xt, { children: [t > 0 && /* @__PURE__ */ A("div", {
			"aria-hidden": !0,
			className: "w-px self-stretch bg-borderSurface"
		}), /* @__PURE__ */ j(u, {
			offset: t === 0 ? void 0 : { months: t },
			className: Ni,
			children: [/* @__PURE__ */ A(f, { children: (e) => {
				let t = a[o];
				return o = (o + 1) % 7, /* @__PURE__ */ A(p, {
					className: Pi,
					children: t ?? e
				});
			} }), /* @__PURE__ */ A(d, { children: (e) => {
				let t = e.compare(Xt(L())) === 0;
				return /* @__PURE__ */ A(l, {
					date: e,
					className: n(...ea, t && n(...Li))
				});
			} })]
		})] }, t))
	})] });
}
//#endregion
//#region src/lib/components/DatePicker/shared/hooks/useBufferedValue.ts
function na({ showFooter: e, value: t, defaultValue: n, onChange: r, initialDraft: i }) {
	let a = t !== void 0, [o, s] = I(t ?? n ?? null), c = a ? t ?? null : o, [l, u] = I(c ?? i ?? null);
	P(() => {
		u(c ?? i ?? null);
	}, [c, i]);
	let d = Tt((e) => {
		a || s(e), r?.(e);
	}, [a, r]), f = Tt(() => {
		u(c ?? i ?? null);
	}, [c, i]), p = Tt(() => {
		Object.is(l, c) || d(l ?? null);
	}, [
		d,
		l,
		c
	]), m = Tt(() => {
		u(c ?? i ?? null);
	}, [c, i]);
	return e ? {
		boundValue: l,
		boundOnChange: u,
		commit: p,
		cancel: m,
		syncFromCommitted: f,
		draft: l,
		committed: c
	} : {
		boundValue: c,
		boundOnChange: (e) => d(e ?? null),
		commit: () => void 0,
		cancel: () => void 0,
		syncFromCommitted: () => void 0,
		draft: c,
		committed: c
	};
}
//#endregion
//#region src/lib/components/DatePicker/DateRangePicker/DsDateRangePicker.tsx
function ra({ height: e, isFullWidth: t, width: r, label: i, description: a, errorMessage: o, variant: s = "display", showYearChevrons: c = !0, showFooter: l = !0, numOfMonths: u = 2, allowsNonContiguousRanges: d = !0, placeholder: f, placement: p, className: m, value: h, defaultValue: g, onChange: _, onOpenChange: v, ...y }) {
	let { t: b } = V(), x = tr(), S = na({
		showFooter: l,
		value: h,
		defaultValue: g,
		onChange: _
	}), C = S.committed, w = Pt({
		dateStyle: "medium",
		timeZone: C && "timeZone" in C.start ? C.start.timeZone : L()
	}), ee = C ? `${w.format(C.start.toDate(L()))} — ${w.format(C.end.toDate(L()))}` : f ?? b("picker.selectDateRange");
	return /* @__PURE__ */ j(T, {
		...y,
		style: Y(y.style, q({
			isFullWidth: t,
			width: r
		})),
		value: S.boundValue,
		onChange: S.boundOnChange,
		allowsNonContiguousRanges: d,
		shouldCloseOnSelect: !l,
		onOpenChange: (e) => {
			e ? S.syncFromCommitted() : l && S.cancel(), v?.(e);
		},
		className: n("group flex flex-col gap-2", m),
		children: [
			i && /* @__PURE__ */ A(X, {
				isRequired: y.isRequired,
				children: i
			}),
			/* @__PURE__ */ A(Ki, {
				variant: s,
				displayText: ee,
				isPlaceholder: !C,
				segmentSlots: ["start", "end"],
				height: e
			}),
			a && /* @__PURE__ */ A(G, { children: a }),
			/* @__PURE__ */ A(K, { children: o }),
			/* @__PURE__ */ j(Ce, {
				placement: p,
				offset: 4,
				boundaryElement: x,
				style: {
					width: Mi(u),
					zIndex: "var(--z-index-popover)"
				},
				className: n(ji, "gap-2"),
				children: [/* @__PURE__ */ A(ke, {
					visibleDuration: { months: u },
					className: "flex flex-col gap-2",
					children: /* @__PURE__ */ A(ta, {
						numOfMonths: u,
						showYearChevrons: c
					})
				}), l && /* @__PURE__ */ A(Ui, {
					onApply: S.commit,
					onCancel: S.cancel,
					isApplyDisabled: S.draft === null
				})]
			})
		]
	});
}
//#endregion
//#region src/lib/components/DatePicker/shared/components/BoxedTimeField.tsx
var ia = /^\p{Cf}+$/u;
function aa({ granularity: e, hourCycle: t = 24, minValue: r, maxValue: i, className: a }) {
	let o = N(w), { t: s } = V();
	return o ? /* @__PURE__ */ j("div", {
		className: n("flex items-center gap-2 w-full", a),
		children: [
			/* @__PURE__ */ A("span", {
				className: "text-sm font-medium text-textSecondary whitespace-nowrap",
				children: s("timeField.label")
			}),
			/* @__PURE__ */ A("span", { className: "flex-1" }),
			/* @__PURE__ */ A("div", {
				dir: "ltr",
				children: /* @__PURE__ */ A(it, {
					"aria-label": s("timeField.label"),
					value: o.timeValue,
					onChange: (e) => {
						e && o.setTimeValue(e);
					},
					granularity: e,
					hourCycle: t,
					minValue: r,
					maxValue: i,
					children: /* @__PURE__ */ A(S, {
						className: "flex items-center gap-1",
						children: (e) => e.type === "literal" ? /* @__PURE__ */ A("span", {
							className: n("text-sm font-semibold text-textSecondary px-1", ia.test(e.text) && "hidden"),
							children: e.text
						}) : /* @__PURE__ */ A("span", {
							className: Vi,
							children: /* @__PURE__ */ A(Gi, { segment: e })
						})
					})
				})
			})
		]
	}) : null;
}
//#endregion
//#region src/lib/components/DatePicker/shared/components/DsCalendar.tsx
var oa = [
	...Fi,
	...Ri,
	...Ii
];
function sa({ showYearChevrons: e, ...t }) {
	let { locale: r } = It(), { t: i } = V(), a = Xi(r, i), o = 0;
	return /* @__PURE__ */ j(c, {
		...t,
		className: "flex flex-col gap-2",
		children: [/* @__PURE__ */ A($i, { showYearChevrons: e }), /* @__PURE__ */ j(u, {
			className: Ni,
			children: [/* @__PURE__ */ A(f, { children: (e) => {
				let t = a[o];
				return o = (o + 1) % 7, /* @__PURE__ */ A(p, {
					className: Pi,
					children: t ?? e
				});
			} }), /* @__PURE__ */ A(d, { children: (e) => {
				let t = e.compare(Xt(L())) === 0;
				return /* @__PURE__ */ A(l, {
					date: e,
					className: n(...oa, t && n(...Li))
				});
			} })]
		})]
	});
}
//#endregion
//#region src/lib/components/DatePicker/shared/utils/timeBounds.ts
function ca(e) {
	return e == null || !("hour" in e) ? null : new Kt(e.hour, e.minute, e.second ?? 0, e.millisecond ?? 0);
}
function la(e, t, n) {
	let r = ca(e);
	if (r === null) return !1;
	let i = ca(t), a = ca(n);
	return i !== null && r.compare(i) < 0 || a !== null && r.compare(a) > 0;
}
//#endregion
//#region src/lib/components/DatePicker/DateTimePicker/DsDateTimePicker.tsx
function ua({ height: e, isFullWidth: t, width: r, label: i, description: a, errorMessage: o, variant: s = "display", showYearChevrons: c = !0, showFooter: l = !0, showSeconds: u = !1, minTime: d, maxTime: f, placeholder: p, placement: m, initialDraft: h, className: g, value: _, defaultValue: v, onChange: y, onOpenChange: b, isInvalid: x, ...S }) {
	let w = u ? "second" : "minute", { t: T } = V(), ee = tr(), E = na({
		showFooter: l,
		value: _,
		defaultValue: v,
		onChange: y,
		initialDraft: h
	}), D = E.committed, te = la(E.draft, d, f), ne = Pt({
		dateStyle: "medium",
		timeStyle: "short",
		timeZone: D && "timeZone" in D ? D.timeZone : L()
	}), re = D ? ne.format(D.toDate(L())) : p ?? T("picker.selectDateTime");
	return /* @__PURE__ */ j(C, {
		...S,
		style: Y(S.style, q({
			isFullWidth: t,
			width: r
		})),
		value: E.boundValue,
		onChange: E.boundOnChange,
		granularity: w,
		hourCycle: 24,
		shouldCloseOnSelect: !1,
		isInvalid: x || te || void 0,
		onOpenChange: (e) => {
			e ? E.syncFromCommitted() : l && E.cancel(), b?.(e);
		},
		className: n("group flex flex-col gap-2", g),
		children: [
			i && /* @__PURE__ */ A(X, {
				isRequired: S.isRequired,
				children: i
			}),
			/* @__PURE__ */ A(Ki, {
				variant: s,
				displayText: re,
				isPlaceholder: !D,
				height: e
			}),
			a && /* @__PURE__ */ A(G, { children: a }),
			/* @__PURE__ */ A(K, { children: o }),
			/* @__PURE__ */ j(Ce, {
				placement: m,
				offset: 4,
				boundaryElement: ee,
				style: {
					width: "var(--trigger-width)",
					minWidth: 280,
					maxWidth: 360,
					zIndex: "var(--z-index-popover)"
				},
				className: ji,
				children: [/* @__PURE__ */ j("div", {
					className: "flex flex-col gap-2",
					children: [
						/* @__PURE__ */ A(sa, { showYearChevrons: c }),
						/* @__PURE__ */ A("div", { className: "h-px w-full bg-borderSecondary" }),
						/* @__PURE__ */ A(aa, {
							granularity: w,
							hourCycle: 24,
							minValue: d,
							maxValue: f
						})
					]
				}), l && /* @__PURE__ */ A(Ui, {
					onApply: E.commit,
					onCancel: E.cancel,
					isApplyDisabled: E.draft === null || te
				})]
			})
		]
	});
}
//#endregion
//#region src/lib/components/DatePicker/DsDatePicker.tsx
function da({ height: e, isFullWidth: t, width: r, label: i, description: a, errorMessage: o, variant: s = "display", showYearChevrons: c = !0, showFooter: l = !0, placeholder: u, placement: d, className: f, value: p, defaultValue: m, onChange: h, onOpenChange: g, ..._ }) {
	let { t: v } = V(), y = na({
		showFooter: l,
		value: p,
		defaultValue: m,
		onChange: h
	}), b = tr(), x = y.committed, S = Pt({
		dateStyle: "medium",
		timeZone: x && "timeZone" in x ? x.timeZone : L()
	}), w = x ? S.format(x.toDate(L())) : u ?? v("picker.selectDate");
	return /* @__PURE__ */ j(C, {
		..._,
		style: Y(_.style, q({
			isFullWidth: t,
			width: r
		})),
		value: y.boundValue,
		onChange: y.boundOnChange,
		shouldCloseOnSelect: !l,
		onOpenChange: (e) => {
			e ? y.syncFromCommitted() : l && y.cancel(), g?.(e);
		},
		className: n("group flex flex-col gap-2", f),
		children: [
			i && /* @__PURE__ */ A(X, {
				isRequired: _.isRequired,
				children: i
			}),
			/* @__PURE__ */ A(Ki, {
				variant: s,
				displayText: w,
				isPlaceholder: !x,
				height: e
			}),
			a && /* @__PURE__ */ A(G, { children: a }),
			/* @__PURE__ */ A(K, { children: o }),
			/* @__PURE__ */ j(Ce, {
				placement: d,
				offset: 4,
				boundaryElement: b,
				style: {
					width: 248,
					zIndex: "var(--z-index-popover)"
				},
				className: ji,
				children: [/* @__PURE__ */ A(sa, { showYearChevrons: c }), l && /* @__PURE__ */ A(Ui, {
					onApply: y.commit,
					onCancel: y.cancel,
					isApplyDisabled: y.draft === null
				})]
			})
		]
	});
}
//#endregion
//#region src/lib/components/DatePicker/RangeCalendarPopover/DsRangeCalendarPopover.tsx
function fa({ isDraftEmpty: e, onApply: t, onCancel: n }) {
	let r = N(Ae), i = r !== null && r.anchorDate !== null;
	return /* @__PURE__ */ A(s.Provider, {
		value: null,
		children: /* @__PURE__ */ A(Ui, {
			onApply: t,
			onCancel: n,
			isApplyDisabled: e || i
		})
	});
}
function pa({ "aria-label": e, isOpen: t, onOpenChange: n, triggerRef: r, value: i, onChange: a, maxValue: o, minValue: s, numOfMonths: c = 2, placement: l = "bottom end" }) {
	let u = tr(), d = na({
		showFooter: !0,
		value: i,
		onChange: (e) => {
			e && a(e);
		}
	}), { syncFromCommitted: f } = d;
	return P(() => {
		t && f();
	}, [t, f]), /* @__PURE__ */ A(Ce, {
		"aria-label": e,
		triggerRef: r,
		isOpen: t,
		onOpenChange: (e) => {
			e || d.cancel(), n(e);
		},
		placement: l,
		offset: 4,
		boundaryElement: u,
		style: {
			width: Mi(c),
			zIndex: "var(--z-index-popover)"
		},
		className: ji,
		children: /* @__PURE__ */ j(ke, {
			autoFocus: !0,
			"aria-label": e,
			value: d.draft,
			onChange: d.boundOnChange,
			minValue: s,
			maxValue: o,
			visibleDuration: { months: c },
			selectionAlignment: "end",
			defaultFocusedValue: i?.end ?? o,
			className: "flex flex-col gap-2",
			children: [/* @__PURE__ */ A(ta, { numOfMonths: c }), /* @__PURE__ */ A(fa, {
				isDraftEmpty: d.draft === null,
				onApply: () => {
					d.commit(), n(!1);
				},
				onCancel: () => {
					d.cancel(), n(!1);
				}
			})]
		})
	});
}
//#endregion
//#region src/lib/components/Dialog/shared/DialogPanel.tsx
var ma = W({ level: "dialog" }).surface(), ha = {
	xs: "max-w-xs",
	sm: "max-w-sm",
	md: "max-w-[440px]",
	lg: "max-w-lg"
}, ga = {
	xs: "w-[min(var(--container-xs),calc(100vw_-_2rem))]",
	sm: "w-[min(var(--container-sm),calc(100vw_-_2rem))]",
	md: "w-[min(440px,calc(100vw_-_2rem))]",
	lg: "w-[min(var(--container-lg),calc(100vw_-_2rem))]"
};
function _a({ title: e, titleEnd: t, children: n, className: r, close: i, closeLabel: a, footer: o, headerClassName: s, headerRef: c, primaryAction: l, secondaryAction: u, showClose: d = !0, role: f, "aria-label": p }) {
	let { t: m } = V(), h = !!o || !!(l || u);
	return /* @__PURE__ */ A(D, {
		role: f,
		"aria-label": p,
		className: M(`relative flex max-h-[inherit] w-full flex-col overflow-clip ${ma} outline outline-0`, r),
		children: ({ close: r }) => {
			let f = i ?? r, p = typeof n == "function" ? n(f) : n, g = typeof o == "function" ? o(f) : o;
			return /* @__PURE__ */ j(k, { children: [
				/* @__PURE__ */ j("div", {
					ref: c,
					className: M("flex items-center gap-3 px-5 py-4", s),
					children: [/* @__PURE__ */ j(oe, {
						slot: "title",
						className: "flex min-w-0 flex-1 items-center gap-3 truncate text-lg/6 font-medium text-textPrimary",
						children: [/* @__PURE__ */ A("span", { children: e }), t]
					}), d && /* @__PURE__ */ A(Fn, {
						name: "x",
						size: "sm",
						"aria-label": a ?? m("common.close"),
						onPress: f,
						className: "-me-2"
					})]
				}),
				p != null && /* @__PURE__ */ A("div", {
					className: "flex flex-col gap-4 overflow-auto border-t border-borderSurface p-5 text-base/5 font-normal text-textSecondary",
					children: p
				}),
				h && /* @__PURE__ */ A("div", {
					className: "flex items-center justify-end gap-3 border-t border-borderSurface px-5 py-4",
					children: g || /* @__PURE__ */ j(k, { children: [u && /* @__PURE__ */ A(H, {
						variant: "secondary",
						size: "lg",
						isPending: u.isPending,
						isDisabled: u.isDisabled,
						onPress: u.onPress,
						children: u.label
					}), l && /* @__PURE__ */ A(H, {
						variant: l.variant === "destructive" ? "destructive" : "primary",
						size: "lg",
						isPending: l.isPending,
						isDisabled: l.isDisabled,
						onPress: l.onPress,
						children: l.label
					})] })
				})
			] });
		}
	});
}
//#endregion
//#region src/lib/components/Dialog/shared/Modal.tsx
var va = r({
	base: "fixed inset-0 z-modal flex items-center justify-center p-4 bg-backgroundOverlay",
	variants: {
		isEntering: { true: "animate-in fade-in duration-200 ease-out" },
		isExiting: { true: "animate-out fade-out duration-200 ease-in" }
	}
}), ya = r({
	base: "w-full max-h-[calc(var(--visual-viewport-height)*.9)]",
	variants: {
		size: ha,
		isEntering: { true: "animate-in motion-safe:zoom-in-105 ease-out duration-200" },
		isExiting: { true: "animate-out motion-safe:zoom-out-95 ease-in duration-200" }
	}
});
function ba({ size: e = "md", isOpen: t, defaultOpen: n, onOpenChange: r, ...i }) {
	return /* @__PURE__ */ A(ye, {
		...i,
		isOpen: t,
		defaultOpen: n,
		onOpenChange: r,
		className: va,
		children: /* @__PURE__ */ A(ve, {
			...i,
			className: (t) => ya({
				...t,
				size: e
			})
		})
	});
}
//#endregion
//#region src/lib/components/Dialog/DsDialog.tsx
function xa({ title: e, titleEnd: t, children: n, className: r, closeLabel: i, footer: a, primaryAction: o, secondaryAction: s, showClose: c = !0, size: l = "md", isDismissable: u = !0, role: d, "aria-label": f, ...p }) {
	return /* @__PURE__ */ A(ba, {
		...p,
		isDismissable: u,
		size: l,
		children: /* @__PURE__ */ A(_a, {
			title: e,
			titleEnd: t,
			className: r,
			closeLabel: i,
			footer: a,
			primaryAction: o,
			secondaryAction: s,
			showClose: c,
			role: d,
			"aria-label": f,
			children: n
		})
	});
}
//#endregion
//#region src/lib/components/Dialog/DsModal.tsx
function Sa({ children: e, className: t, size: n = "md", isDismissable: r = !0, role: i, "aria-label": a, "aria-labelledby": o, ...s }) {
	return /* @__PURE__ */ A(ba, {
		...s,
		isDismissable: r,
		size: n,
		children: /* @__PURE__ */ A(D, {
			role: i,
			"aria-label": a,
			"aria-labelledby": o,
			className: M("relative max-h-[inherit] outline-none", t),
			children: ({ close: t }) => typeof e == "function" ? e(t) : e
		})
	});
}
//#endregion
//#region src/lib/components/Dialog/shared/hooks/useDraggable.ts
function Z(e, t, n) {
	return Math.min(Math.max(e, t), n);
}
function Ca(e) {
	return getComputedStyle(e).direction === "rtl";
}
function wa(e, t) {
	switch (e) {
		case "top-start": return t ? "top-right" : "top-left";
		case "top-end": return t ? "top-left" : "top-right";
		case "bottom-start": return t ? "bottom-right" : "bottom-left";
		case "bottom-end": return t ? "bottom-left" : "bottom-right";
		default: return e;
	}
}
function Ta(e) {
	return e === "top-right" || e === "bottom-right";
}
function Ea(e, t) {
	if (typeof t == "object") return {
		left: t.x,
		top: t.y
	};
	let n = e.offsetHeight;
	switch (t) {
		case "center": return {
			left: Math.max(16, (window.innerWidth - e.offsetWidth) / 2),
			top: Math.max(16, (window.innerHeight - n) / 2)
		};
		case "top-left": return {
			left: 16,
			top: 16
		};
		case "top-right": return {
			right: 16,
			top: 16
		};
		case "bottom-left": return {
			left: 16,
			top: window.innerHeight - n - 16
		};
		case "bottom-right": return {
			right: 16,
			top: window.innerHeight - n - 16
		};
		default: return {
			left: 16,
			top: 16
		};
	}
}
function Da({ enabled: e, initialPosition: t }) {
	let n = F(null), r = F(null), i = F(t), a = F(!1), [o, s] = I(!1);
	return Dt(() => {
		let e = n.current;
		if (!e) return;
		let t = wa(i.current, Ca(e)), { left: r = 0, right: o, top: s } = Ea(e, t);
		o === void 0 ? (e.style.left = `${r}px`, e.style.right = "auto") : (e.style.left = "auto", e.style.right = `${o}px`), e.style.top = `${s}px`;
		let c = () => {
			let n = e.getBoundingClientRect(), r = Math.max(0, window.innerWidth - e.offsetWidth), i = Math.max(0, window.innerHeight - e.offsetHeight);
			if (t === "center" && !a.current) {
				e.style.left = `${Z((window.innerWidth - e.offsetWidth) / 2, 0, r)}px`, e.style.right = "auto", e.style.top = `${Z((window.innerHeight - e.offsetHeight) / 2, 0, i)}px`;
				return;
			}
			if (Ta(t)) {
				let t = window.innerWidth - n.right;
				e.style.right = `${Z(t, 0, r)}px`, e.style.left = "auto";
			} else e.style.left = `${Z(n.left, 0, r)}px`, e.style.right = "auto";
			e.style.top = `${Z(n.top, 0, i)}px`;
		};
		window.addEventListener("resize", c);
		let l = typeof ResizeObserver > "u" ? void 0 : new ResizeObserver(c);
		return l?.observe(e), () => {
			window.removeEventListener("resize", c), l?.disconnect();
		};
	}, []), P(() => {
		if (!e) return;
		let t = n.current, o = r.current;
		if (!t || !o) return;
		o.style.touchAction = "none";
		let c = 0, l = 0, u = 0, d = 0, f = 0, p = 0, m = 0, h = !1, g = 0, _ = null, v = Ta(wa(i.current, Ca(t))), y = (e) => {
			if (!h || e.pointerId !== g) return;
			if (e.pointerType === "mouse" && e.buttons === 0) {
				x(e);
				return;
			}
			e.preventDefault(), a.current = !0;
			let n = e.clientX - c, r = e.clientY - l, i = Math.max(0, window.innerWidth - p), o = Math.max(0, window.innerHeight - m);
			v ? (t.style.right = `${Z(d - n, 0, i)}px`, t.style.left = "auto") : (t.style.left = `${Z(u + n, 0, i)}px`, t.style.right = "auto"), t.style.top = `${Z(f + r, 0, o)}px`;
		}, b = () => {
			_ !== null && o.hasPointerCapture?.(_) && o.releasePointerCapture(_), _ = null;
		}, x = (e) => {
			!h || e && e.pointerId !== g || (b(), h = !1, s(!1), document.removeEventListener("pointermove", y, !0), document.removeEventListener("pointerup", x, !0), document.removeEventListener("pointercancel", x, !0));
		}, S = (e) => {
			let n = e.target, r = e.button === 0;
			if (h || !r || n?.closest("button, input, select, textarea, label, [role=\"button\"]")) return;
			e.preventDefault();
			let i = t.getBoundingClientRect();
			h = !0, g = e.pointerId, s(!0), c = e.clientX, l = e.clientY, u = i.left, d = window.innerWidth - i.right, f = i.top, p = t.offsetWidth, m = t.offsetHeight, o.setPointerCapture && (o.setPointerCapture(e.pointerId), _ = e.pointerId), document.addEventListener("pointermove", y, !0), document.addEventListener("pointerup", x, !0), document.addEventListener("pointercancel", x, !0);
		};
		return o.addEventListener("pointerdown", S, !0), () => {
			x(), b(), o.style.touchAction = "", o.removeEventListener("pointerdown", S, !0);
		};
	}, [e]), {
		panelRef: n,
		handleRef: r,
		isDragging: o
	};
}
//#endregion
//#region src/lib/components/Dialog/FloatingDialog/DsFloatingDialog.tsx
function Oa({ isOpen: e = !0, ...t }) {
	return e ? /* @__PURE__ */ A(ka, { ...t }) : null;
}
function ka({ title: e, titleEnd: t, children: n, className: r, closeLabel: i, footer: a, allowsDragging: o = !0, initialPosition: s = "center", onOpenChange: c, primaryAction: l, secondaryAction: u, showClose: d = !0, size: f = "md" }) {
	let { panelRef: p, handleRef: m, isDragging: h } = Da({
		enabled: o,
		initialPosition: s
	}), g = h ? "cursor-grabbing" : o ? "cursor-grab" : void 0;
	return /* @__PURE__ */ A(jt, { children: /* @__PURE__ */ A("div", {
		ref: p,
		className: "fixed z-modal",
		children: /* @__PURE__ */ A(_a, {
			title: e,
			titleEnd: t,
			className: M(ga[f], r),
			close: () => c?.(!1),
			closeLabel: i,
			footer: a,
			primaryAction: l,
			secondaryAction: u,
			showClose: d,
			headerRef: m,
			headerClassName: M("select-none", g),
			children: n
		})
	}) });
}
//#endregion
//#region src/lib/components/Display/DsDisplay.tsx
var Aa = r({
	base: "font-bold text-balance text-textPrimary",
	variants: { size: {
		xs: "text-6xl",
		sm: "text-7xl",
		md: "text-8xl",
		lg: "text-9xl",
		xl: "text-10xl"
	} },
	defaultVariants: { size: "md" }
});
function ja({ elementType: e = "p", ref: t, size: n, ...r }) {
	return Ct(e, {
		...r,
		ref: t,
		className: Aa({
			size: n,
			className: r.className
		})
	});
}
//#endregion
//#region src/lib/components/Drawer/helpers/drawerStyles.ts
var Ma = r({ slots: {
	panel: "fixed inset-y-0 end-0 z-modal flex w-(--drawer-width) max-w-full flex-col overflow-clip max-md:w-full border-s border-borderSurface bg-backgroundRaised shadow-xl motion-safe:animate-in motion-safe:slide-in-from-end duration-200 ease-out",
	dialog: "flex min-h-0 flex-1 flex-col outline-none",
	header: "flex shrink-0 items-center gap-3 border-b border-borderSurface px-5 py-4",
	title: "min-w-0 flex-1 truncate text-lg/6 font-medium text-textPrimary",
	body: "min-h-0 flex-1 overflow-y-auto p-5 text-base/5 font-normal text-textSecondary",
	footer: "flex shrink-0 flex-col gap-3 border-t border-borderSurface p-5"
} });
//#endregion
//#region src/lib/components/Drawer/components/DrawerPanel.tsx
function Na({ title: e, children: t, width: n = 420, primaryAction: r, secondaryAction: i, showClose: a = !0, closeLabel: o, className: s, close: c }) {
	let { t: l } = V(), u = F(null), d = Ma(), f = !!(r || i), { overlayProps: p } = Rt({
		isOpen: !0,
		onClose: c,
		isDismissable: !1
	}, u), m = { "--drawer-width": typeof n == "number" ? `${n}px` : n };
	return /* @__PURE__ */ A(At, {
		restoreFocus: !0,
		children: /* @__PURE__ */ A("div", {
			...p,
			ref: u,
			className: d.panel({ className: s }),
			style: m,
			children: /* @__PURE__ */ j(D, {
				className: d.dialog(),
				children: [
					/* @__PURE__ */ j("div", {
						className: d.header(),
						children: [/* @__PURE__ */ A(oe, {
							slot: "title",
							className: d.title(),
							children: e
						}), a && /* @__PURE__ */ A(Fn, {
							name: "x",
							size: "sm",
							"aria-label": o ?? l("common.close"),
							onPress: c,
							className: "-me-2"
						})]
					}),
					/* @__PURE__ */ A("div", {
						className: d.body(),
						children: typeof t == "function" ? t(c) : t
					}),
					f && /* @__PURE__ */ j("div", {
						className: d.footer(),
						children: [r && /* @__PURE__ */ A(H, {
							variant: r.variant === "destructive" ? "destructive" : "primary",
							size: "md",
							className: "w-full",
							isPending: r.isPending,
							isDisabled: r.isDisabled,
							onPress: r.onPress,
							children: r.label
						}), i && /* @__PURE__ */ A(H, {
							variant: "secondary",
							size: "md",
							className: "w-full",
							isPending: i.isPending,
							isDisabled: i.isDisabled,
							onPress: i.onPress,
							children: i.label
						})]
					})
				]
			})
		})
	});
}
//#endregion
//#region src/lib/components/Drawer/DsDrawer.tsx
function Pa({ isOpen: e, defaultOpen: t, onOpenChange: n, ...r }) {
	let i = Zt({
		isOpen: e,
		defaultOpen: t,
		onOpenChange: n
	}), a = N(Se), o = a && !(e !== void 0 || t !== void 0) ? a : i;
	return /* @__PURE__ */ A(Se.Provider, {
		value: o,
		children: o.isOpen && /* @__PURE__ */ A(jt, {
			disableFocusManagement: !0,
			children: /* @__PURE__ */ A(Na, {
				...r,
				close: o.close
			})
		})
	});
}
//#endregion
//#region src/lib/components/DropZone/DsDropZone.tsx
var Fa = `outline ${gr}`, Ia = r({
	base: "flex flex-col items-center justify-center gap-1 px-4 py-3 min-h-18 text-base text-balance text-center rounded-md border border-dashed border-borderPrimary text-textPrimary",
	variants: {
		isHovered: { true: "bg-backgroundHover" },
		isFocusVisible: { true: Fa },
		isDropTarget: { true: `bg-backgroundHover ${Fa}` },
		isDisabled: { true: `${B} forced-colors:border-[GrayText] forced-colors:text-[GrayText]` }
	}
});
function La({ height: e, isFullWidth: t, width: n, ...r }) {
	return /* @__PURE__ */ A(te, {
		...r,
		style: Y(r.style, {
			...q({
				isFullWidth: t,
				width: n
			}, null),
			...J(e, null)
		}),
		className: O(r.className, (e, t) => Ia({
			...t,
			className: e
		}))
	});
}
//#endregion
//#region src/lib/components/FileTrigger/DsFileTrigger.tsx
function Ra(e) {
	return /* @__PURE__ */ A(re, { ...e });
}
//#endregion
//#region src/lib/components/Link/DsLink.tsx
var za = r({
	base: `${z} underline cursor-pointer disabled:opacity-disabled disabled:cursor-not-allowed forced-colors:disabled:text-[GrayText] transition rounded-xs`,
	variants: { variant: {
		primary: "text-textBrand underline decoration-brandPrimaryStrong hover:decoration-textBrand",
		secondary: "text-textPrimary underline decoration-textTertiary hover:decoration-textPrimary",
		subtle: "inline-flex items-center gap-0.5 no-underline text-textSecondary hover:text-textPrimary"
	} },
	defaultVariants: { variant: "primary" }
}), Ba = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
function Va(e) {
	window.location.assign(e);
}
function Ha(e) {
	return e;
}
function Ua(e) {
	let t = /* @__PURE__ */ A(le, {
		...e,
		className: O(e.className, (t, n) => za({
			...n,
			className: t,
			variant: e.variant
		}))
	});
	return e.href !== void 0 && Ba.test(e.href) ? /* @__PURE__ */ A(Me, {
		navigate: Va,
		useHref: Ha,
		children: t
	}) : t;
}
//#endregion
//#region src/lib/components/NumberField/DsNumberField.tsx
function Wa({ height: t, isFullWidth: n, width: r, label: i, description: a, errorMessage: o, placeholder: s, ...c }) {
	return /* @__PURE__ */ j(be, {
		...c,
		style: Y(c.style, q({
			isFullWidth: n,
			width: r
		})),
		className: U(c.className, "group flex flex-col gap-2"),
		children: [
			i && /* @__PURE__ */ A(X, {
				isRequired: c.isRequired,
				isRequiredAnnouncedByInput: !0,
				children: i
			}),
			/* @__PURE__ */ j(kr, {
				height: t,
				children: [/* @__PURE__ */ A(Nr, { placeholder: s }), /* @__PURE__ */ j("div", {
					className: `flex flex-col self-stretch border-s border-borderPrimary pointer-coarse:flex-row-reverse ${_r}`,
					children: [
						/* @__PURE__ */ A(Ga, {
							slot: "increment",
							children: /* @__PURE__ */ A(e, {
								name: "chevron-up",
								"aria-hidden": !0,
								size: "sm"
							})
						}),
						/* @__PURE__ */ A("div", { className: "border-b border-borderPrimary pointer-coarse:border-b-0 pointer-coarse:border-s" }),
						/* @__PURE__ */ A(Ga, {
							slot: "decrement",
							children: /* @__PURE__ */ A(e, {
								name: "chevron-down",
								"aria-hidden": !0,
								size: "sm"
							})
						})
					]
				})]
			}),
			a && /* @__PURE__ */ A(G, { children: a }),
			/* @__PURE__ */ A(K, { children: o })
		]
	});
}
function Ga(e) {
	return /* @__PURE__ */ A(o, {
		...e,
		className: "flex flex-1 box-border items-center justify-center border-0 px-1 py-0 pointer-coarse:px-2.5 cursor-pointer text-textSecondary bg-transparent pressed:bg-backgroundMuted group-disabled:text-textDisabled forced-colors:group-disabled:text-[GrayText]"
	});
}
//#endregion
//#region src/lib/components/Pagination/components/PaginationEllipsis.tsx
function Ka({ className: e }) {
	return /* @__PURE__ */ A("span", {
		"aria-hidden": "true",
		className: n("flex items-center justify-center -me-px px-4 py-2", "border border-borderSecondary bg-backgroundRaised text-base font-medium text-textTertiary", e),
		children: "…"
	});
}
//#endregion
//#region src/lib/components/Pagination/components/PaginationItem.tsx
var qa = [
	z,
	"relative flex items-center justify-center -me-px last:me-0",
	"border border-borderSecondary bg-backgroundRaised text-base font-medium whitespace-nowrap",
	"transition cursor-pointer focus-visible:z-10"
], Ja = "bg-[image:linear-gradient(var(--backgroundHover),var(--backgroundHover))]", Ya = 20, Xa = r({
	base: qa,
	variants: {
		kind: {
			page: "px-4 py-2 text-textPrimary",
			previous: "p-2 text-textSecondary rounded-s-md",
			next: "p-2 text-textSecondary rounded-e-md"
		},
		isHovered: { true: Ja },
		isPressed: { true: Ja },
		isCurrent: { true: "z-[1] cursor-default bg-brandPrimary border-brandPrimary text-textOnBrandPrimary" },
		isDisabled: { true: B }
	},
	compoundVariants: [
		{
			isCurrent: !0,
			isHovered: !0,
			class: "bg-none"
		},
		{
			isCurrent: !0,
			isPressed: !0,
			class: "bg-none"
		},
		{
			kind: ["previous", "next"],
			isDisabled: !0,
			class: "text-textTertiary"
		}
	]
});
function Za({ kind: t, isCurrent: n = !1, isDisabled: r = !1, children: i, className: a, ...s }) {
	return /* @__PURE__ */ j(o, {
		...s,
		isDisabled: r,
		"aria-current": n ? "page" : void 0,
		"data-current": n || void 0,
		className: (e) => Xa({
			...e,
			kind: t,
			isCurrent: n,
			className: a
		}),
		children: [
			t === "page" && i,
			t === "previous" && /* @__PURE__ */ A(e, {
				name: "chevron-left",
				size: Ya,
				className: "rtl:-scale-x-100"
			}),
			t === "next" && /* @__PURE__ */ A(e, {
				name: "chevron-right",
				size: Ya,
				className: "rtl:-scale-x-100"
			})
		]
	});
}
//#endregion
//#region src/lib/components/Pagination/helpers/getPaginationRange.ts
var Qa = {
	type: "ellipsis",
	position: "start"
}, $a = {
	type: "ellipsis",
	position: "end"
};
function Q(e, t) {
	let n = Math.max(0, t - e + 1);
	return Array.from({ length: n }, (t, n) => ({
		type: "page",
		page: e + n
	}));
}
function eo({ page: e, totalPages: t, siblingCount: n, boundaryCount: r }) {
	if (n * 2 + 3 + r * 2 >= t) return Q(1, t);
	let i = Math.max(e - n, r), a = Math.min(e + n, t - r), o = i > r + 2, s = a < t - (r + 1);
	if (!o && s) return [
		...Q(1, n * 2 + r + 2),
		$a,
		...Q(t - r + 1, t)
	];
	if (o && !s) {
		let e = r + 1 + n * 2;
		return [
			...Q(1, r),
			Qa,
			...Q(t - e, t)
		];
	}
	return [
		...Q(1, r),
		Qa,
		...Q(i, a),
		$a,
		...Q(t - r + 1, t)
	];
}
//#endregion
//#region src/lib/components/Pagination/hooks/usePaginationState.ts
var to = 1, no = 1, ro = 1;
function io(e, t, n) {
	return Math.min(Math.max(e, t), n);
}
function ao({ count: e, pageSize: t, page: n, defaultPage: r = to, onPageChange: i, siblingCount: a = no, boundaryCount: o = ro }) {
	let [s, c] = $t(n, r, i), l = Math.max(1, t), u = Math.max(1, Math.ceil(e / l)), d = io(s, 1, u), f = (e) => {
		let t = io(e, 1, u);
		t !== d && c(t);
	};
	return {
		page: d,
		totalPages: u,
		from: e === 0 ? 0 : (d - 1) * l + 1,
		to: Math.min(d * l, e),
		items: eo({
			page: d,
			totalPages: u,
			siblingCount: a,
			boundaryCount: o
		}),
		isFirstPage: d === 1,
		isLastPage: d === u,
		setPage: f,
		next: () => f(d + 1),
		previous: () => f(d - 1)
	};
}
//#endregion
//#region src/lib/components/Pagination/DsPagination.tsx
function oo({ count: e, pageSize: t, page: r, defaultPage: i, onPageChange: a, siblingCount: o, boundaryCount: s, isDisabled: c = !1, id: l, className: u, "aria-label": d }) {
	let { t: f } = V(), p = Lt(), m = ao({
		count: e,
		pageSize: t,
		page: r,
		defaultPage: i,
		onPageChange: a,
		siblingCount: o,
		boundaryCount: s
	}), h = F(null), g = F(null), [_, v] = I(null), [y, b] = I(null), x = c || m.isFirstPage, S = c || m.isLastPage;
	_ === "next" && S && (v(null), b(x ? null : "previous")), _ === "previous" && x && (v(null), b(S ? null : "next")), P(() => {
		y === "previous" && h.current?.focus(), y === "next" && g.current?.focus();
	}, [y]);
	function C(e) {
		return (t) => {
			if (t) {
				v(e), b(null);
				return;
			}
			v((t) => t === e ? null : t);
		};
	}
	let w = f("pagination.summary", {
		count: e,
		from: p.format(m.from),
		to: p.format(m.to),
		total: p.format(e)
	});
	return /* @__PURE__ */ j("nav", {
		id: l,
		"aria-label": d ?? f("pagination.aria.navigation"),
		className: n("@container flex w-full flex-wrap items-center justify-between gap-x-4 gap-y-3 p-4", u),
		children: [/* @__PURE__ */ A("p", {
			className: "text-base text-textSecondary",
			children: w
		}), /* @__PURE__ */ j("div", {
			className: "ms-auto flex",
			children: [
				/* @__PURE__ */ A(Za, {
					ref: h,
					kind: "previous",
					"aria-label": f("pagination.aria.previous"),
					isDisabled: x,
					onPress: m.previous,
					onFocusChange: C("previous")
				}),
				/* @__PURE__ */ j("span", {
					className: "hidden items-center justify-center -me-px border border-borderSecondary bg-backgroundRaised px-4 py-2 text-base font-medium whitespace-nowrap tabular-nums text-textPrimary @max-[480px]:flex",
					children: [
						p.format(m.page),
						" / ",
						p.format(m.totalPages)
					]
				}),
				m.items.map((e) => e.type === "ellipsis" ? /* @__PURE__ */ A(Ka, { className: "@max-[480px]:hidden" }, `ellipsis-${e.position}`) : /* @__PURE__ */ A(Za, {
					kind: "page",
					"aria-label": f("pagination.aria.page", { page: p.format(e.page) }),
					isCurrent: e.page === m.page,
					isDisabled: c,
					onPress: () => m.setPage(e.page),
					className: "@max-[480px]:hidden",
					children: p.format(e.page)
				}, e.page)),
				/* @__PURE__ */ A(Za, {
					ref: g,
					kind: "next",
					"aria-label": f("pagination.aria.next"),
					isDisabled: S,
					onPress: m.next,
					onFocusChange: C("next")
				})
			]
		})]
	});
}
//#endregion
//#region src/lib/components/Pagination/PrevNextButtons/DsPrevNextButtons.tsx
var so = "me-0";
function co({ previousLabel: e, nextLabel: t, onPreviousPress: r, onNextPress: i, className: a, isNextDisabled: o = !1, isPreviousDisabled: s = !1 }) {
	let c = F(null), l = F(null), [u, d] = I(null), [f, p] = I(null);
	u === "next" && o && (d(null), p(s ? null : "previous")), u === "previous" && s && (d(null), p(o ? null : "next")), P(() => {
		f === "previous" && c.current?.focus(), f === "next" && l.current?.focus();
	}, [f]);
	function m(e) {
		return (t) => {
			if (t) {
				d(e), p(null);
				return;
			}
			d((t) => t === e ? null : t);
		};
	}
	return /* @__PURE__ */ j("div", {
		className: n("flex gap-2", a),
		children: [/* @__PURE__ */ A(Za, {
			ref: c,
			kind: "previous",
			"aria-label": e,
			isDisabled: s,
			onPress: r,
			onFocusChange: m("previous"),
			className: so
		}), /* @__PURE__ */ A(Za, {
			ref: l,
			kind: "next",
			"aria-label": t,
			isDisabled: o,
			onPress: i,
			onFocusChange: m("next"),
			className: so
		})]
	});
}
//#endregion
//#region src/lib/components/PinInput/PinInputCell.tsx
var lo = r({
	base: "flex w-11 min-w-8 flex-1 items-center justify-center rounded-lg bg-backgroundField px-1 py-3.5 text-xl/7 text-textPrimary outline transition forced-colors:bg-[Field]",
	variants: {
		isActive: {
			false: hr,
			true: gr
		},
		isInvalid: { true: "outline-2 -outline-offset-2 outline-borderDangerPrimary text-textDangerPrimary forced-colors:outline-[Mark]" },
		isDisabled: { true: `${B} forced-colors:outline-[GrayText]` }
	}
});
function uo({ char: e, isActive: t, isInvalid: n, isDisabled: r, isReadOnly: i }) {
	let a = e !== void 0 && e !== "", o = t && !a && !i && !r;
	return /* @__PURE__ */ A("div", {
		"aria-hidden": !0,
		"data-active": t || void 0,
		"data-filled": a || void 0,
		className: lo({
			isActive: t,
			isInvalid: n,
			isDisabled: r
		}),
		children: /* @__PURE__ */ j("span", {
			className: "flex min-h-lh items-center",
			children: [a && e, o && /* @__PURE__ */ A("span", { className: "h-6 w-0.5 rounded-[1px] bg-textSecondary motion-safe:animate-pulse" })]
		})
	});
}
//#endregion
//#region src/lib/components/PinInput/DsPinInput.tsx
var fo = 6;
function po(e, t) {
	return e.replace(/\D/g, "").slice(0, t);
}
function mo(e) {
	let t = e.currentTarget, n = t.value.length;
	(t.selectionStart !== n || t.selectionEnd !== n) && t.setSelectionRange(n, n);
}
function ho({ height: e, isFullWidth: t, width: n, length: r = fo, value: i, defaultValue: a, onChange: o, onComplete: s, label: c, description: l, errorMessage: u, inputRef: d, className: f, ...p }) {
	let [m, h] = I(() => po(a ?? "", r)), { focusProps: g, isFocused: _, isFocusVisible: v } = Ft({ isTextInput: !0 }), y = () => i === void 0 ? m : po(i, r), b = (e) => {
		let t = y(), n = po(e, r);
		i === void 0 && h(n), n !== t && o?.(n), n.length === r && t.length !== r && s?.(n);
	}, x = y(), S = x.length === r, C = Math.min(x.length, r - 1), w = Array.from({ length: r }, (e, t) => t);
	return /* @__PURE__ */ A(rt, {
		...p,
		value: x,
		onChange: b,
		"data-complete": S || void 0,
		"data-focused": _ || void 0,
		"data-focus-visible": v || void 0,
		style: q({
			isFullWidth: t,
			width: n
		}, null),
		className: U(f, "group flex w-fit max-w-full flex-col gap-2"),
		children: ({ isDisabled: t, isInvalid: n, isReadOnly: r, isRequired: i }) => /* @__PURE__ */ j(k, { children: [
			c && /* @__PURE__ */ A(X, {
				isRequired: i,
				isRequiredAnnouncedByInput: !0,
				children: c
			}),
			/* @__PURE__ */ A(ie, {
				style: J(e, null),
				className: "relative flex gap-2",
				children: ({ isFocusWithin: e }) => /* @__PURE__ */ j(k, { children: [w.map((i) => /* @__PURE__ */ A(uo, {
					char: x[i],
					isActive: e && i === C,
					isInvalid: n,
					isDisabled: t,
					isReadOnly: r
				}, i)), /* @__PURE__ */ A("div", {
					className: "absolute inset-0 overflow-hidden",
					children: /* @__PURE__ */ A(se, {
						ref: d,
						inputMode: "numeric",
						autoComplete: "one-time-code",
						pattern: "[0-9]*",
						...Nt(g, {
							onFocus: mo,
							onSelect: mo
						}),
						className: "absolute inset-y-0 start-0 -end-3 cursor-default opacity-0 [caret-color:transparent] disabled:cursor-not-allowed"
					})
				})] })
			}),
			l && /* @__PURE__ */ A(G, { children: l }),
			/* @__PURE__ */ A(K, { children: u })
		] })
	});
}
//#endregion
//#region src/lib/components/Portal/DsPortalProvider.tsx
function go({ children: e, getContainer: t }) {
	return /* @__PURE__ */ A(Mt, {
		getContainer: t,
		children: e
	});
}
//#endregion
//#region src/lib/components/ProgressBar/DsProgressBar.tsx
var _o = r({
	slots: {
		root: "flex flex-col w-64 max-w-full",
		value: "ms-auto text-textSecondary",
		track: "max-w-full rounded-full bg-borderPrimary outline -outline-offset-1 outline-transparent relative overflow-hidden"
	},
	variants: { size: {
		sm: {
			root: "gap-1",
			value: "text-sm/5",
			track: "h-1"
		},
		md: {
			root: "gap-2",
			value: "text-base",
			track: "h-2"
		}
	} },
	defaultVariants: { size: "md" }
});
function vo({ label: e, showLabel: t, showValueLabel: n, size: r = "md", ...i }) {
	let a = t ?? !!e, o = n ?? !!e, s = _o({ size: r });
	return /* @__PURE__ */ A(Te, {
		...i,
		className: U(i.className, s.root()),
		children: ({ percentage: t, valueText: n, isIndeterminate: r }) => /* @__PURE__ */ j(k, { children: [(a || o) && /* @__PURE__ */ j("div", {
			className: "flex justify-between gap-2",
			children: [a && /* @__PURE__ */ A(X, { children: e }), o && !r && /* @__PURE__ */ A("span", {
				className: s.value(),
				children: n
			})]
		}), /* @__PURE__ */ A("div", {
			className: s.track(),
			children: /* @__PURE__ */ A("div", {
				className: `absolute top-0 h-full rounded-full bg-brandPrimary forced-colors:bg-[Highlight] ${r ? "start-full animate-in duration-1000 slide-in-from-left-[350%] rtl:slide-in-from-right-[350%] repeat-infinite ease-out" : "start-0"}`,
				style: { width: (r ? 40 : t) + "%" }
			})
		})] })
	});
}
//#endregion
//#region src/lib/components/RadioGroup/DsRadioGroup.tsx
var yo = r({
	extend: Ur,
	base: "justify-center rounded-full",
	variants: { size: {
		sm: Fr.sm,
		md: Fr.md
	} }
}), bo = r({
	base: "rounded-full bg-textOnBrandPrimary forced-colors:bg-[HighlightText]",
	variants: { size: {
		sm: "size-[7px]",
		md: "size-2"
	} }
});
function xo({ children: e, description: t, errorMessage: n, label: r, ...i }) {
	return /* @__PURE__ */ A(Oe, {
		...i,
		className: U(i.className, "group flex flex-col gap-2"),
		children: ({ isRequired: i }) => /* @__PURE__ */ j(k, { children: [
			r && /* @__PURE__ */ A(X, {
				isRequired: i,
				isRequiredAnnouncedByInput: !0,
				children: r
			}),
			/* @__PURE__ */ A("div", {
				className: "flex gap-3 group-orientation-vertical:flex-col group-orientation-horizontal:gap-6",
				children: e
			}),
			t && /* @__PURE__ */ A(G, { children: t }),
			/* @__PURE__ */ A(K, { children: n })
		] })
	});
}
function So({ children: e, className: t, controlPlacement: n = "start", description: r, size: i = "md", ...a }) {
	return /* @__PURE__ */ j(De, {
		...a,
		className: Rr({
			controlPlacement: n,
			variant: "default"
		}),
		children: [/* @__PURE__ */ A(Ee, {
			className: O(t, (e, t) => zr({
				...t,
				controlPlacement: n,
				size: i,
				className: e
			})),
			children: O(e, (e, { isSelected: t, ...r }) => /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A("span", {
				className: Br({ size: i }),
				children: /* @__PURE__ */ A("span", {
					className: yo({
						...r,
						isSelected: t,
						size: i
					}),
					children: t && /* @__PURE__ */ A("span", { className: bo({ size: i }) })
				})
			}), /* @__PURE__ */ A("span", {
				className: Vr({
					controlPlacement: n,
					size: i,
					variant: "default"
				}),
				children: e
			})] }))
		}), r && /* @__PURE__ */ A(G, {
			className: Hr({
				controlPlacement: n,
				size: i
			}),
			children: r
		})]
	});
}
//#endregion
//#region src/lib/components/Select/shared/SelectOverlay.tsx
function Co({ items: e, dependencies: t, placement: n, renderEmptyState: r, children: i }) {
	return /* @__PURE__ */ A(ir, {
		placement: n,
		className: "min-w-(--trigger-width) max-w-[calc(100vw-1.5rem)] has-[[data-empty]]:max-w-(--trigger-width)",
		children: /* @__PURE__ */ A(Qn, {
			itemCount: N(Ie)?.collection.size ?? 0,
			items: e,
			dependencies: t,
			renderEmptyState: r && ((e) => /* @__PURE__ */ A("div", {
				className: "flex items-center justify-center px-3 py-4 text-center text-base/5 text-textSecondary select-none forced-colors:text-[GrayText]",
				children: r(e)
			})),
			className: Hn,
			children: i
		})
	});
}
//#endregion
//#region src/lib/components/Select/shared/SelectTriggerContent.tsx
function wo(e) {
	return typeof e == "string" && t.includes(e);
}
function To(e) {
	if (typeof e != "object" || !e) return {};
	let { iconStart: t, textEnd: n } = e;
	return {
		iconStart: wo(t) ? t : void 0,
		textEnd: typeof n == "string" ? n : void 0
	};
}
function Eo({ chevronClassName: t = "", chevronSize: n, iconSize: r, iconStart: i, isChevronHidden: a, mutedClassName: o = "" }) {
	let s = N(Ie), { locale: c } = It(), l = Ot(() => new Intl.ListFormat(c, {
		style: "narrow",
		type: "conjunction"
	}), [c]), u = s?.selectedItems ?? [], d = u.length === 1 ? To(u[0].props) : void 0, f = i ?? d?.iconStart;
	return /* @__PURE__ */ j(k, { children: [
		f && /* @__PURE__ */ A(e, {
			name: f,
			"aria-hidden": !0,
			size: r,
			className: `shrink-0 ${o}`
		}),
		/* @__PURE__ */ A(Le, {
			className: "min-w-0 truncate data-placeholder:text-textPlaceholder",
			children: ({ selectedText: e, defaultChildren: t }) => u.length > 1 ? l.format(u.map((e) => e.textValue)) : e || t
		}),
		d?.textEnd && /* @__PURE__ */ A("span", {
			className: `shrink-0 truncate ${o}`,
			children: d.textEnd
		}),
		!a && /* @__PURE__ */ A(e, {
			name: "chevron-down",
			"aria-hidden": !0,
			size: n,
			className: `ms-auto shrink-0 transition-transform group-open:rotate-180 forced-colors:text-[ButtonText] ${o} ${t}`
		})
	] });
}
//#endregion
//#region src/lib/components/Select/DsSelect.tsx
var Do = "text-start text-textPrimary";
function Oo({ allowsEmptyCollection: e, height: t, isFullWidth: n, width: r, label: i, description: a, errorMessage: s, placeholder: c, placement: l, children: u, dependencies: d, isReadOnly: f, items: p, renderEmptyState: m, ...h }) {
	let { t: g } = V();
	function _() {
		return h.isDisabled ? Do : f ? `cursor-default ${Do}` : `cursor-pointer ${Do}`;
	}
	return /* @__PURE__ */ A(Fe, {
		...h,
		"data-readonly": f || void 0,
		allowsEmptyCollection: e ?? m !== void 0,
		placeholder: c ?? g("select.placeholder"),
		style: Y(h.style, q({
			isFullWidth: n,
			width: r
		})),
		className: U(h.className, "group flex min-w-0 flex-col gap-2"),
		children: ({ isOpen: e, isInvalid: n, isRequired: r }) => /* @__PURE__ */ j(k, { children: [
			i && /* @__PURE__ */ A(X, {
				isRequired: r,
				children: i
			}),
			/* @__PURE__ */ A(o, {
				isDisabled: h.isDisabled || f,
				style: J(t),
				className: ({ isFocusVisible: t }) => br({
					isFocusWithin: t || e,
					isInvalid: n,
					isDisabled: h.isDisabled,
					className: _()
				}),
				children: /* @__PURE__ */ A(Eo, {
					iconSize: "md",
					chevronSize: "md",
					isChevronHidden: f,
					mutedClassName: "text-textSecondary"
				})
			}),
			a && /* @__PURE__ */ A(G, { children: a }),
			/* @__PURE__ */ A(K, { children: s }),
			/* @__PURE__ */ A(Co, {
				items: p,
				dependencies: d,
				placement: l,
				renderEmptyState: m,
				children: u
			})
		] })
	});
}
function ko(e) {
	return /* @__PURE__ */ A(qn, { ...e });
}
function Ao(e) {
	return /* @__PURE__ */ A(er, { ...e });
}
//#endregion
//#region src/lib/components/Select/SelectCompact/helpers/compactTriggerStyles.ts
var jo = {
	md: "sm",
	lg: "md"
}, Mo = r({
	base: `${z} flex items-center gap-1 px-2 py-1.5 rounded-md cursor-pointer transition`,
	variants: {
		size: {
			md: "text-base/5 font-medium text-textSecondary",
			lg: "text-xl/6 font-semibold text-textPrimary"
		},
		isFilled: { true: "" },
		isOpen: { true: "" },
		isHovered: { true: "" },
		isDisabled: { true: `${B} forced-colors:text-[GrayText]` }
	},
	compoundVariants: [
		{
			size: "md",
			isFilled: !0,
			class: "text-textPrimary"
		},
		{
			size: "md",
			isHovered: !0,
			class: "bg-backgroundHover text-textPrimary"
		},
		{
			size: "md",
			isOpen: !0,
			class: "bg-backgroundHover text-textPrimary inset-ring-1 inset-ring-borderPrimary"
		},
		{
			size: "md",
			isDisabled: !0,
			class: "text-textTertiary"
		},
		{
			size: "lg",
			isHovered: !0,
			class: "bg-backgroundHover"
		},
		{
			size: "lg",
			isOpen: !0,
			class: "bg-backgroundHover"
		}
	],
	defaultVariants: { size: "md" }
}), No = r({
	variants: {
		size: {
			md: "text-textTertiary",
			lg: ""
		},
		isFilled: { true: "" },
		isOpen: { true: "" },
		isHovered: { true: "" },
		isDisabled: { true: "" }
	},
	compoundVariants: [
		{
			size: "md",
			isFilled: !0,
			class: "text-textSecondary"
		},
		{
			size: "md",
			isHovered: !0,
			class: "text-textSecondary"
		},
		{
			size: "md",
			isOpen: !0,
			class: "text-textSecondary"
		},
		{
			size: "md",
			isDisabled: !0,
			class: "text-textTertiary"
		}
	]
});
//#endregion
//#region src/lib/components/Select/SelectCompact/DsCompactTrigger.tsx
function Po({ children: t, isFilled: n = !1, isOpen: r = !1, size: i = "md", ...a }) {
	return /* @__PURE__ */ A(o, {
		...a,
		className: (e) => Mo({
			...e,
			isFilled: n,
			isOpen: r,
			size: i
		}),
		children: (a) => /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A("span", {
			className: "min-w-0 truncate",
			children: t
		}), /* @__PURE__ */ A(e, {
			name: "chevron-down",
			"aria-hidden": !0,
			size: jo[i],
			className: `ms-auto shrink-0 transition-transform forced-colors:text-[ButtonText] ${r ? "rotate-180" : ""} ${No({
				...a,
				isFilled: n,
				isOpen: r,
				size: i
			})}`
		})] })
	});
}
//#endregion
//#region src/lib/components/Select/SelectCompact/DsSelectCompact.tsx
function Fo({ allowsEmptyCollection: e, height: t, isFullWidth: n, width: r, iconStart: i, isFilled: a = !1, placeholder: s, placement: c, size: l = "md", children: u, dependencies: d, items: f, renderEmptyState: p, ...m }) {
	let { t: h } = V();
	return /* @__PURE__ */ A(Fe, {
		...m,
		allowsEmptyCollection: e ?? p !== void 0,
		placeholder: s ?? h("select.placeholder"),
		style: Y(m.style, q({
			isFullWidth: n,
			width: r
		}, null)),
		className: U(m.className, "group inline-flex flex-col"),
		children: ({ isOpen: e }) => /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A(o, {
			style: J(t, null),
			className: (t) => Mo({
				...t,
				isFilled: a,
				isOpen: e,
				size: l
			}),
			children: (t) => /* @__PURE__ */ A(Eo, {
				iconSize: jo[l],
				chevronSize: jo[l],
				chevronClassName: No({
					...t,
					isFilled: a,
					isOpen: e,
					size: l
				}),
				iconStart: i
			})
		}), /* @__PURE__ */ A(Co, {
			items: f,
			dependencies: d,
			placement: c,
			renderEmptyState: p,
			children: u
		})] })
	});
}
//#endregion
//#region src/lib/components/Separator/DsSeparator.tsx
var Io = r({
	base: "bg-borderPrimary forced-colors:bg-[ButtonBorder] border-none",
	variants: { orientation: {
		horizontal: "h-px w-full",
		vertical: "w-px min-h-8 h-full"
	} },
	defaultVariants: { orientation: "horizontal" }
});
function Lo(e) {
	return /* @__PURE__ */ A(ze, {
		...e,
		className: Io({
			orientation: e.orientation,
			className: e.className
		})
	});
}
//#endregion
//#region src/lib/hooks/useMediaQuery.ts
var Ro = {
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	"2xl": 1536
}, zo = .02;
function Bo(e) {
	return typeof e == "string" ? e : "below" in e ? `(max-width: ${Ro[e.below] - zo}px)` : `(min-width: ${Ro[e.above]}px)`;
}
function Vo(e) {
	let t = Bo(e);
	return kt((e) => {
		let n = window.matchMedia(t);
		return n.addEventListener("change", e), () => n.removeEventListener("change", e);
	}, () => window.matchMedia(t).matches, () => !1);
}
//#endregion
//#region src/lib/hooks/useScreenSize.ts
function Ho() {
	let e = Vo({ below: "md" }), t = Vo({ above: "lg" });
	return {
		isMobile: e,
		isTablet: !e && !t,
		isDesktop: t
	};
}
//#endregion
//#region src/lib/components/Sidebar/helpers/isSidebarGroup.ts
function Uo(e) {
	return "items" in e;
}
//#endregion
//#region src/lib/components/Sidebar/components/SidebarBrand.tsx
var Wo = r({
	base: "flex h-16 shrink-0 items-center",
	variants: { isCollapsed: {
		true: "justify-center",
		false: "ps-2"
	} }
}), Go = r({ base: `${z} flex rounded-sm` });
function Ko({ logo: e, isCollapsed: t }) {
	let n = t ? e.shortLogoSrc : e.fullLogoSrc;
	if (!n) return null;
	let r = /* @__PURE__ */ A("img", {
		src: n,
		alt: e.alt,
		className: "h-auto max-h-14 w-auto max-w-full"
	});
	return /* @__PURE__ */ A("div", {
		className: Wo({ isCollapsed: t }),
		children: e.href === void 0 ? r : /* @__PURE__ */ A(le, {
			href: e.href,
			className: (e) => Go(e),
			children: r
		})
	});
}
//#endregion
//#region src/lib/components/Sidebar/helpers/sidebarRow.ts
var qo = r({
	base: [
		z,
		"flex w-full items-center gap-3 rounded-md -outline-offset-2",
		"text-start text-base font-medium text-textPrimary",
		"cursor-pointer",
		"motion-safe:transition-colors"
	],
	variants: {
		isSubItem: {
			true: "py-2 ps-3.5 pe-2",
			false: "p-2"
		},
		isCollapsed: { true: "justify-center" },
		fill: {
			none: "",
			hover: "bg-backgroundHover",
			current: "bg-brandPrimaryMuted"
		},
		isBrand: { true: "text-textBrand" }
	}
});
function Jo({ isFilled: e, isHovered: t, isPressed: n }) {
	return e ? "current" : t || n ? "hover" : "none";
}
//#endregion
//#region src/lib/components/Sidebar/components/SidebarNavItem.tsx
var Yo = r({
	base: "size-1.5 shrink-0 rounded-full bg-textTertiary motion-safe:transition-colors",
	variants: { isCurrent: { true: "bg-brandPrimary" } }
});
function Xo({ item: t, icon: r, isCollapsed: i, isInFlyout: a = !1, onPress: s }) {
	let c = t.isCurrent ?? !1, l = () => {
		t.onAction?.(), s?.();
	}, u = ({ isHovered: e, isPressed: t }) => qo({
		isSubItem: r === void 0 && !a,
		isCollapsed: i,
		fill: Jo({
			isFilled: c,
			isHovered: e,
			isPressed: t
		}),
		isBrand: c,
		class: n("group", !c && !e && !t && "text-textSecondary")
	}), d = /* @__PURE__ */ j(k, { children: [
		r === void 0 ? /* @__PURE__ */ A("span", {
			"aria-hidden": !0,
			className: Yo({ isCurrent: c })
		}) : /* @__PURE__ */ A(e, {
			name: r,
			size: "md",
			"aria-hidden": !0,
			className: n("shrink-0", !c && "text-textTertiary group-data-[hovered]:text-textPrimary group-data-[pressed]:text-textPrimary")
		}),
		i ? /* @__PURE__ */ A("span", {
			className: "sr-only",
			children: t.label
		}) : /* @__PURE__ */ A("span", {
			className: "min-w-0 flex-1 line-clamp-2 break-words",
			children: t.label
		}),
		!i && t.badge && /* @__PURE__ */ A(ri, {
			size: "sm",
			shape: "square",
			variant: t.badge.variant ?? "neutral",
			className: "ms-auto shrink-0",
			children: t.badge.label
		})
	] }), f = t.href === void 0 ? /* @__PURE__ */ A(o, {
		onPress: l,
		"data-current": c || void 0,
		className: u,
		children: d
	}) : /* @__PURE__ */ A(le, {
		href: t.href,
		target: t.target,
		rel: t.rel,
		onPress: l,
		"aria-current": c ? "page" : void 0,
		className: u,
		children: d
	});
	return i ? /* @__PURE__ */ j(jn, { children: [f, /* @__PURE__ */ A(Mn, {
		placement: "end",
		children: t.label
	})] }) : f;
}
//#endregion
//#region src/lib/components/Sidebar/components/SidebarGroupFlyout.tsx
var Zo = r({
	base: "flex items-center gap-2 px-2 pt-1 pb-2 text-base font-medium text-textPrimary",
	variants: { hasCurrent: { true: "text-textBrand" } }
});
function Qo({ group: t, defaultOpen: n = !1, onItemPress: r }) {
	let i = Et(), [a, s] = I(n), c = t.items.some((e) => e.isCurrent === !0), [l] = t.items, u = ({ isHovered: e, isPressed: t }) => qo({
		isSubItem: !1,
		isCollapsed: !0,
		fill: Jo({
			isFilled: !1,
			isHovered: e,
			isPressed: t
		}),
		isBrand: c,
		className: "aria-expanded:bg-backgroundHover"
	}), d = () => {
		l.onAction?.(), r?.();
	}, f = () => {
		s(!1), r?.();
	}, p = /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A(e, {
		name: t.icon,
		size: "md",
		"aria-hidden": !0,
		className: "shrink-0"
	}), /* @__PURE__ */ A("span", {
		className: "sr-only",
		children: t.label
	})] });
	return /* @__PURE__ */ j(we, {
		delay: 100,
		isOpen: a,
		onOpenChange: s,
		children: [l.href === void 0 ? /* @__PURE__ */ A(o, {
			onPress: d,
			className: u,
			children: p
		}) : /* @__PURE__ */ A(le, {
			href: l.href,
			target: l.target,
			rel: l.rel,
			onPress: d,
			"aria-current": l.isCurrent ? "page" : void 0,
			className: u,
			children: p
		}), /* @__PURE__ */ j(ir, {
			placement: "end top",
			offset: 16,
			"aria-labelledby": i,
			className: "flex w-50 flex-col gap-2 rounded-xl bg-backgroundFloating p-2 ring-borderSurface dark:ring-borderSurface",
			children: [/* @__PURE__ */ j("div", {
				className: Zo({ hasCurrent: c }),
				children: [/* @__PURE__ */ A("span", {
					id: i,
					className: "min-w-0 truncate",
					children: t.label
				}), t.badge !== void 0 && /* @__PURE__ */ A(ri, {
					size: "sm",
					shape: "pill",
					variant: t.badge.variant ?? "neutral",
					className: "shrink-0",
					children: t.badge.label
				})]
			}), /* @__PURE__ */ A("ul", {
				className: "flex flex-col gap-1",
				children: t.items.map((e) => /* @__PURE__ */ A("li", { children: /* @__PURE__ */ A(Xo, {
					item: e,
					isCollapsed: !1,
					isInFlyout: !0,
					onPress: f
				}) }, e.id))
			})]
		})]
	});
}
//#endregion
//#region src/lib/components/Sidebar/components/SidebarNavGroup.tsx
var $o = r({
	base: "ms-auto shrink-0 motion-safe:transition-transform",
	variants: { isExpanded: { true: "rotate-180" } }
});
function es({ group: t, isCollapsed: n, isExpanded: r, onExpandedToggle: i, onItemPress: a }) {
	let s = Et(), c = t.items.some((e) => e.isCurrent === !0);
	return n ? /* @__PURE__ */ A(Qo, {
		group: t,
		onItemPress: a
	}) : /* @__PURE__ */ j("div", {
		className: "flex flex-col gap-1",
		children: [/* @__PURE__ */ j(o, {
			"aria-expanded": r,
			"aria-controls": r ? s : void 0,
			"data-current": c || void 0,
			onPress: i,
			className: ({ isHovered: e, isPressed: t }) => qo({
				isSubItem: !1,
				isCollapsed: !1,
				fill: Jo({
					isFilled: !1,
					isHovered: e,
					isPressed: t
				}),
				isBrand: c
			}),
			children: [
				/* @__PURE__ */ A(e, {
					name: t.icon,
					size: "md",
					"aria-hidden": !0,
					className: "shrink-0"
				}),
				/* @__PURE__ */ A("span", {
					className: "min-w-0 line-clamp-2 break-words",
					children: t.label
				}),
				t.badge !== void 0 && /* @__PURE__ */ A(ri, {
					size: "sm",
					shape: "pill",
					variant: t.badge.variant ?? "neutral",
					className: "shrink-0",
					children: t.badge.label
				}),
				/* @__PURE__ */ A(e, {
					name: "chevron-down",
					size: "sm",
					"aria-hidden": !0,
					className: $o({ isExpanded: r })
				})
			]
		}), r && /* @__PURE__ */ A("ul", {
			id: s,
			className: "flex flex-col gap-1",
			children: t.items.map((e) => /* @__PURE__ */ A("li", { children: /* @__PURE__ */ A(Xo, {
				item: e,
				isCollapsed: !1,
				onPress: a
			}) }, e.id))
		})]
	});
}
//#endregion
//#region src/lib/components/Sidebar/components/SidebarProfileRow.tsx
var ts = r({
	base: "flex h-10 min-w-0 shrink-0 items-center gap-3",
	variants: { isCollapsed: {
		true: "justify-center",
		false: "w-full"
	} }
});
function ns({ profile: e, isCollapsed: t }) {
	return t ? /* @__PURE__ */ A("div", {
		className: ts({ isCollapsed: t }),
		children: /* @__PURE__ */ A(ei, {
			size: "sm",
			src: e.avatarSrc,
			initials: e.initials,
			alt: e.name
		})
	}) : /* @__PURE__ */ j("div", {
		className: ts({ isCollapsed: t }),
		children: [/* @__PURE__ */ A(ei, {
			size: "sm",
			src: e.avatarSrc,
			initials: e.initials,
			"aria-hidden": !0
		}), /* @__PURE__ */ j("div", {
			className: "flex min-w-0 flex-col",
			children: [/* @__PURE__ */ A("span", {
				className: "truncate text-base font-medium text-textPrimary",
				children: e.name
			}), e.caption && /* @__PURE__ */ A("span", {
				className: "truncate text-sm text-textSecondary",
				children: e.caption
			})]
		})]
	});
}
//#endregion
//#region src/lib/components/Sidebar/components/SidebarContent.tsx
function rs(e) {
	return e.map((e) => ({
		...e,
		items: e.items.filter((e) => !Uo(e) || e.items.length > 0)
	})).filter((e) => e.items.length > 0);
}
function is({ sections: e, bottomItems: t, expandedKeys: r, logo: i, profile: a, navId: o, isCollapsed: s, onExpandedToggle: c, onItemPress: l, "aria-label": u }) {
	let d = n("flex flex-col gap-1", s && "items-center");
	return /* @__PURE__ */ j(k, { children: [
		i && /* @__PURE__ */ A(Ko, {
			logo: i,
			isCollapsed: s
		}),
		/* @__PURE__ */ A("nav", {
			id: o,
			"aria-label": u,
			className: n("min-h-0 w-full flex-1 overflow-y-auto first:pt-4", ln),
			children: /* @__PURE__ */ A("div", {
				className: "flex flex-col gap-2",
				children: rs(e).map((e, t) => /* @__PURE__ */ j(xt, { children: [t > 0 && /* @__PURE__ */ A("div", {
					"aria-hidden": !0,
					className: "my-4 h-px shrink-0 bg-borderTertiary"
				}), /* @__PURE__ */ A("ul", {
					className: d,
					children: e.items.map((e) => /* @__PURE__ */ A("li", { children: Uo(e) ? /* @__PURE__ */ A(es, {
						group: e,
						isCollapsed: s,
						isExpanded: r.has(e.id),
						onExpandedToggle: () => c(e.id),
						onItemPress: l
					}) : /* @__PURE__ */ A(Xo, {
						item: e,
						icon: e.icon,
						isCollapsed: s,
						onPress: l
					}) }, e.id))
				})] }, e.id))
			})
		}),
		a && /* @__PURE__ */ A(ns, {
			profile: a,
			isCollapsed: s
		}),
		t.length > 0 && /* @__PURE__ */ A("ul", {
			className: d,
			children: t.map((e) => /* @__PURE__ */ A("li", { children: /* @__PURE__ */ A(Xo, {
				item: e,
				icon: e.icon,
				isCollapsed: s,
				onPress: l
			}) }, e.id))
		})
	] });
}
//#endregion
//#region src/lib/components/Sidebar/components/SidebarMobilePanel.tsx
var as = r({
	base: "fixed inset-0 z-modal bg-backgroundOverlay",
	variants: {
		isEntering: { true: "animate-in fade-in duration-200 ease-out" },
		isExiting: { true: "animate-out fade-out duration-200 ease-in" }
	}
}), os = r({
	base: `fixed inset-y-0 start-0 flex w-60 flex-col outline-0 ${W({ level: "drawer" }).surface()}`,
	variants: {
		isEntering: { true: "animate-in motion-safe:slide-in-from-start ease-out duration-200" },
		isExiting: { true: "animate-out motion-safe:slide-out-to-start ease-in duration-200" }
	}
});
function ss({ children: e, isOpen: t, onOpenChange: n, id: r, "aria-label": i }) {
	return /* @__PURE__ */ A(ye, {
		isOpen: t,
		onOpenChange: n,
		isDismissable: !0,
		className: as,
		children: /* @__PURE__ */ A(ve, {
			className: os,
			children: /* @__PURE__ */ A(D, {
				id: r,
				"aria-label": i,
				className: "flex h-full flex-col gap-4 px-6 pb-4 outline-0",
				children: e
			})
		})
	});
}
//#endregion
//#region src/lib/components/Sidebar/components/SidebarCollapseToggle.tsx
var cs = {
	rest: "M16 4L16 9.29289C16 9.68342 16 10.3166 16 10.7071L16 16",
	collapse: "M13 4L7.70711 9.29289C7.31658 9.68342 7.31658 10.3166 7.70711 10.7071L13 16",
	expand: "M7 4L12.2929 9.29289C12.6834 9.68342 12.6834 10.3166 12.2929 10.7071L7 16"
}, ls = r({
	base: ["absolute top-1/2 size-9 -translate-y-1/2 outline-0", `cursor-pointer ${sn}`],
	variants: { isCollapsed: {
		true: "-end-6.5",
		false: "-end-4.5"
	} }
}), us = r({
	base: [
		cn,
		"absolute top-2 size-5 rounded-full",
		"motion-safe:transition-[inset-inline-start] motion-safe:duration-120 motion-safe:ease-out"
	],
	variants: {
		isCollapsed: {
			true: "start-1",
			false: "start-3"
		},
		isActive: { true: "" }
	},
	compoundVariants: [{
		isCollapsed: !0,
		isActive: !0,
		class: "start-3"
	}]
}), ds = r({
	base: "motion-safe:transition-[d,stroke] motion-safe:duration-120 motion-safe:ease-out",
	variants: { isActive: {
		true: "stroke-textBrandHover",
		false: "stroke-brandPrimarySubtle"
	} }
});
function fs({ isCollapsed: e, navId: t, onPress: n }) {
	let { t: r } = V();
	return /* @__PURE__ */ A(o, {
		onPress: n,
		"aria-label": r(e ? "sidebar.aria.expand" : "sidebar.aria.collapse"),
		"aria-expanded": !e,
		"aria-controls": t,
		className: `peer ${ls({ isCollapsed: e })}`,
		children: ({ isHovered: t, isPressed: n, isFocusVisible: r }) => {
			let i = t || n || r, a = i ? e ? cs.expand : cs.collapse : cs.rest;
			return /* @__PURE__ */ A("span", {
				className: us({
					isCollapsed: e,
					isActive: i
				}),
				children: /* @__PURE__ */ A("svg", {
					viewBox: "0 0 20 20",
					fill: "none",
					strokeWidth: 2,
					strokeLinecap: "round",
					"aria-hidden": !0,
					className: "size-full rtl:-scale-x-100",
					children: /* @__PURE__ */ A("path", {
						d: a,
						style: { d: `path("${a}")` },
						className: ds({ isActive: i })
					})
				})
			});
		}
	});
}
//#endregion
//#region src/lib/components/Sidebar/components/SidebarRail.tsx
var ps = r({
	base: ["sticky top-0 z-10 flex h-dvh shrink-0 flex-col gap-4 bg-backgroundNav", "motion-safe:transition-[width] motion-safe:duration-200"],
	variants: { isCollapsed: {
		true: "w-16 items-center px-2 pb-4",
		false: "w-60 px-6 pb-4"
	} }
}), ms = r({
	base: ["pointer-events-none absolute inset-y-0 end-0 -z-1 w-px bg-borderTertiary", "motion-safe:transition-[inset-inline-end] motion-safe:duration-120 motion-safe:ease-out"],
	variants: { isCollapsed: {
		true: "peer-data-hovered:-end-1 peer-data-pressed:-end-1 peer-data-focus-visible:-end-1",
		false: "peer-data-hovered:end-1 peer-data-pressed:end-1 peer-data-focus-visible:end-1"
	} }
});
function hs({ sections: e, bottomItems: t, expandedKeys: n, logo: r, profile: i, isCollapsed: a, allowsCollapsing: o, onCollapseToggle: s, onExpandedToggle: c, id: l, className: u, "aria-label": d }) {
	let f = Et();
	return /* @__PURE__ */ j("div", {
		id: l,
		"data-collapsed": a || void 0,
		className: ps({
			isCollapsed: a,
			className: u
		}),
		children: [
			/* @__PURE__ */ A(is, {
				"aria-label": d,
				navId: f,
				sections: e,
				bottomItems: t,
				expandedKeys: n,
				logo: r,
				profile: i,
				isCollapsed: a,
				onExpandedToggle: c
			}),
			o && /* @__PURE__ */ A(fs, {
				isCollapsed: a,
				navId: f,
				onPress: s
			}),
			/* @__PURE__ */ A("span", {
				"aria-hidden": !0,
				className: ms({ isCollapsed: a })
			})
		]
	});
}
//#endregion
//#region src/lib/components/Sidebar/helpers/getAutoExpandedKeys.ts
function gs(e, t, n) {
	return t === null || t === n || e.has(t) ? null : /* @__PURE__ */ new Set([...e, t]);
}
//#endregion
//#region src/lib/components/Sidebar/helpers/resolveCurrent.ts
function _s(e) {
	return e !== void 0 && e.startsWith("/") && !e.startsWith("//");
}
function vs(e) {
	let t = e.replace(/[?#].*$/, "");
	return t.length > 1 && t.endsWith("/") ? t.slice(0, -1) : t;
}
function ys(e, t) {
	return t === e || t.startsWith(`${e}/`);
}
function bs(e) {
	let t = [];
	for (let n of e.sections) for (let e of n.items) Uo(e) ? t.push(...e.items) : t.push(e);
	return [...t, ...e.bottomItems];
}
function xs(e, t) {
	let n = vs(t), r = null, i = -1;
	for (let t of e) {
		if (t.isCurrent !== void 0 || !_s(t.href)) continue;
		let e = vs(t.href);
		ys(e, n) && e.length > i && (r = t, i = e.length);
	}
	return r;
}
function Ss(e, t) {
	return e.isCurrent === void 0 ? {
		...e,
		isCurrent: e === t
	} : e;
}
function Cs(e, t) {
	if (t === void 0) return e;
	let n = xs(bs(e), t);
	return {
		sections: e.sections.map((e) => ({
			...e,
			items: e.items.map((e) => Uo(e) ? {
				...e,
				items: e.items.map((e) => Ss(e, n))
			} : Ss(e, n))
		})),
		bottomItems: e.bottomItems.map((e) => Ss(e, n))
	};
}
function ws(e) {
	for (let t of e) for (let e of t.items) if (Uo(e) && e.items.some((e) => e.isCurrent === !0)) return e.id;
	return null;
}
//#endregion
//#region src/lib/components/Sidebar/DsSidebar.tsx
function Ts({ sections: e, bottomItems: t = [], currentPath: n, logo: r, profile: i, allowsCollapsing: a = !0, isCollapsed: o, defaultCollapsed: s = !1, onCollapsedChange: c, expandedKeys: l, defaultExpandedKeys: u, onExpandedChange: d, isMobileOpen: f, defaultMobileOpen: p = !1, onMobileOpenChange: m, id: h, className: g, "aria-label": _ }) {
	let v = Et(), { isDesktop: y } = Ho(), [b, x] = $t(o, s, c), [S, C] = $t(f, p, m), w = Cs({
		sections: e,
		bottomItems: t
	}, n), T = ws(w.sections), [ee] = I(() => T === null ? [] : [T]), { expandedKeys: E, setExpandedKeys: D, toggleKey: te } = en({
		expandedKeys: l,
		defaultExpandedKeys: u ?? ee,
		onExpandedChange: d,
		allowsMultipleExpanded: !0
	}), ne = F(T), re = F(!1);
	return P(() => {
		let e = ne.current;
		ne.current = T;
		let t = gs(E, T, e);
		t !== null && D(t);
	}, [
		T,
		E,
		D
	]), P(() => {
		let e = y && !re.current;
		re.current = y, e && S && C(!1);
	}, [
		y,
		S,
		C
	]), y ? /* @__PURE__ */ A(hs, {
		id: h,
		className: g,
		"aria-label": _,
		sections: w.sections,
		bottomItems: w.bottomItems,
		expandedKeys: E,
		logo: r,
		profile: i,
		isCollapsed: b,
		allowsCollapsing: a,
		onCollapseToggle: () => x(!b),
		onExpandedToggle: te
	}) : /* @__PURE__ */ A(ss, {
		id: h,
		"aria-label": _,
		isOpen: S,
		onOpenChange: C,
		children: /* @__PURE__ */ A(is, {
			"aria-label": _,
			navId: v,
			sections: w.sections,
			bottomItems: w.bottomItems,
			expandedKeys: E,
			logo: r,
			profile: i,
			isCollapsed: !1,
			onExpandedToggle: te,
			onItemPress: () => C(!1)
		})
	});
}
//#endregion
//#region src/lib/components/Switch/DsSwitch.tsx
var Es = r({
	extend: Ur,
	base: "rounded-full px-px shadow-inner",
	variants: { size: {
		sm: Ir.sm,
		md: Ir.md
	} }
}), Ds = r({
	base: "rounded-full shadow-sm transition",
	variants: {
		isSelected: {
			false: "translate-x-0 bg-backgroundMutedHover forced-colors:bg-[ButtonText]",
			true: "translate-x-full rtl:-translate-x-full bg-textOnBrandPrimary forced-colors:bg-[HighlightText]"
		},
		size: {
			sm: Lr.sm,
			md: Lr.md
		}
	}
});
function Os({ children: e, className: t, controlPlacement: n = "start", description: r, errorMessage: i, size: a = "md", ...o }) {
	let s = Hr({
		controlPlacement: n,
		size: a
	});
	return /* @__PURE__ */ j(He, {
		...o,
		className: Rr({
			controlPlacement: n,
			variant: "default"
		}),
		children: [
			/* @__PURE__ */ A(Ve, {
				className: O(t, (e, t) => zr({
					...t,
					controlPlacement: n,
					size: a,
					className: e
				})),
				children: O(e, (e, { isSelected: t, ...r }) => /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A("span", {
					className: Br({ size: a }),
					children: /* @__PURE__ */ A("span", {
						className: Es({
							...r,
							isSelected: t,
							size: a
						}),
						children: /* @__PURE__ */ A("span", { className: Ds({
							isSelected: t,
							size: a
						}) })
					})
				}), /* @__PURE__ */ A("span", {
					className: Vr({
						controlPlacement: n,
						size: a,
						variant: "default"
					}),
					children: e
				})] }))
			}),
			r && /* @__PURE__ */ A(G, {
				className: s,
				children: r
			}),
			/* @__PURE__ */ A(K, {
				className: s,
				children: i
			})
		]
	});
}
//#endregion
//#region src/lib/components/Table/components/TreeExpandButton.tsx
var ks = r({
	base: "border-0 p-0 pe-1 bg-transparent shrink-0 align-middle cursor-pointer",
	variants: { isDisabled: { true: "text-textDisabled forced-colors:text-[GrayText]" } }
}), As = r({
	base: "text-textSecondary transition-transform duration-200 ease-in-out rtl:-scale-x-100",
	variants: {
		isExpanded: { true: "transform rotate-90" },
		isDisabled: { true: "text-textDisabled forced-colors:text-[GrayText]" }
	}
});
function js({ isDisabled: t, isExpanded: n }) {
	return /* @__PURE__ */ A(o, {
		slot: "chevron",
		className: ks({ isDisabled: t }),
		children: /* @__PURE__ */ A(e, {
			name: "chevron-right",
			size: "sm",
			className: As({
				isExpanded: n,
				isDisabled: t
			})
		})
	});
}
//#endregion
//#region src/lib/components/Table/DsCell.tsx
var Ms = r({
	base: `${z} box-border border-b border-b-borderTertiary group-last/row:border-b-transparent px-4 pt-3 pb-2.75 truncate -outline-offset-2 group-data-[variant=raised]/table:group-last/row:first:rounded-es-2xl group-data-[variant=raised]/table:group-last/row:last:rounded-ee-2xl`,
	variants: {
		variant: {
			primary: "font-medium",
			secondary: "font-normal text-textSecondary"
		},
		align: {
			start: "text-start",
			end: "text-end tabular-nums"
		}
	}
});
function Ns({ variant: e = "primary", align: t = "start", isMuted: n = !1, subtext: r, delta: i, ...a }) {
	let o = !!i;
	return /* @__PURE__ */ A(h, {
		...a,
		className: (n) => Ms({
			...n,
			variant: e,
			align: t,
			className: a.className
		}),
		style: ({ hasChildItems: e, isTreeColumn: t, level: n }) => ({ paddingInlineStart: t ? 4 + (e ? 0 : 20) + (n - 1) * 16 : void 0 }),
		children: O(a.children, (e, { hasChildItems: t, isTreeColumn: a, isExpanded: s, isDisabled: c }) => {
			let l = e;
			return n && (l = /* @__PURE__ */ A("span", {
				className: "opacity-50",
				children: e
			})), (r !== void 0 || o) && (l = /* @__PURE__ */ j(k, { children: [
				/* @__PURE__ */ A("span", {
					className: M("block truncate", n && "opacity-50"),
					children: e
				}),
				r !== void 0 && /* @__PURE__ */ A("span", {
					className: M("block truncate text-sm leading-4 font-normal text-textSecondary", n && "opacity-50"),
					children: r
				}),
				o && /* @__PURE__ */ A("span", {
					className: M("block text-sm leading-4", n && "opacity-50"),
					children: i
				})
			] })), /* @__PURE__ */ j(k, { children: [t && a && /* @__PURE__ */ A(js, {
				isDisabled: c,
				isExpanded: s
			}), l] });
		})
	});
}
//#endregion
//#region src/lib/components/Table/hooks/useReportedWidth.ts
function Ps(e, t, n, r) {
	Dt(() => {
		let r = e.current;
		if (!n || !(r instanceof HTMLElement) || !document.fonts) return;
		function i() {
			r instanceof HTMLElement && n?.(t(r));
		}
		return i(), document.fonts.addEventListener("loadingdone", i), () => {
			document.fonts.removeEventListener("loadingdone", i);
		};
	}, [
		r,
		t,
		n,
		e
	]);
}
//#endregion
//#region src/lib/components/Table/components/ColumnContentSample.tsx
function Fs(e) {
	return Math.ceil(e.getBoundingClientRect().width);
}
function Is({ children: e, onWidthChange: t }) {
	let n = F(null);
	return Ps(n, Fs, t, e), /* @__PURE__ */ A("div", {
		"aria-hidden": !0,
		className: "invisible h-0 overflow-hidden",
		children: /* @__PURE__ */ A("div", {
			ref: n,
			className: "flex w-max flex-col items-start",
			children: e
		})
	});
}
//#endregion
//#region src/lib/components/Tooltip/hooks/useDsTooltipTrigger.ts
function Ls(e = {}) {
	let t = F(null), n = {
		...e,
		delay: 100,
		closeDelay: 100
	}, r = Qt(n), { triggerProps: i, tooltipProps: a } = Vt(n, r, t);
	return {
		anchor: {
			state: r,
			tooltipProps: a,
			triggerRef: t
		},
		triggerProps: i,
		triggerRef: t
	};
}
//#endregion
//#region src/lib/components/Table/components/ColumnLabel.tsx
function Rs(e, t) {
	return t ? e.scrollWidth > e.clientWidth : e.scrollHeight > e.clientHeight;
}
function zs(e) {
	return e.scrollWidth + 1;
}
function Bs({ children: e, maxLines: t, onWidthChange: n }) {
	let r = Ls(), [i, a] = I(!1), o = t <= 1;
	Ps(r.triggerRef, zs, n, e);
	function s(e) {
		a(Rs(e.currentTarget, o)), r.triggerProps.onMouseEnter?.(e);
	}
	return /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A("span", {
		ref: r.triggerRef,
		...r.triggerProps,
		"aria-describedby": i ? r.triggerProps["aria-describedby"] : void 0,
		onMouseEnter: s,
		className: M("min-w-0", o ? "truncate" : "overflow-hidden break-words [display:-webkit-box] [-webkit-box-orient:vertical]"),
		style: o ? void 0 : { WebkitLineClamp: t },
		children: e
	}), /* @__PURE__ */ A(Mn, {
		anchor: r.anchor,
		isOpen: i && r.anchor.state.isOpen,
		children: e
	})] });
}
//#endregion
//#region src/lib/components/Table/components/SortIndicator.tsx
function Vs({ direction: t }) {
	return /* @__PURE__ */ A("span", {
		className: "w-4 h-4 flex items-center justify-center",
		children: /* @__PURE__ */ A(e, {
			name: t === "descending" ? "chevron-down" : "chevron-up",
			size: "sm",
			className: "forced-colors:text-[ButtonText]"
		})
	});
}
//#endregion
//#region src/lib/components/Table/helpers/getFittedMinWidth.ts
var Hs = 32, Us = 20;
function Ws({ minWidth: e, labelWidth: t, contentWidth: n, allowsSorting: r }) {
	let i = r ? Us : 0, a = t ? t + Hs + i : 0, o = n ? n + Hs : 0, s = Math.max(a, o);
	return s === 0 || typeof e == "string" ? e : Math.max(e ?? 0, s);
}
//#endregion
//#region src/lib/components/Table/helpers/tableStyles.ts
var Gs = r({
	base: `group/table relative box-border w-full overflow-auto scroll-pt-11 ${ln}`,
	variants: { variant: {
		raised: rn,
		plain: ""
	} },
	defaultVariants: { variant: "raised" }
}), Ks = r({
	base: "box-border",
	variants: { variant: {
		filled: "bg-backgroundHover",
		plain: "border-b border-borderSecondary"
	} },
	defaultVariants: { variant: "filled" }
}), qs = St("filled");
function Js() {
	return N(qs);
}
//#endregion
//#region src/lib/components/Table/DsColumn.tsx
var Ys = r({
	base: `${z} -outline-offset-2 px-4 h-5 box-border flex-1 flex gap-1 items-center overflow-hidden`,
	variants: {
		align: {
			start: "",
			end: "justify-end"
		},
		isMultiline: { true: "h-auto" }
	}
}), Xs = r({ base: `${z} w-px px-[8px] translate-x-[8px] rtl:-translate-x-[8px] box-content py-1 -my-1 h-5 bg-clip-content bg-borderPrimary forced-colors:bg-[ButtonBorder] cursor-col-resize rounded-xs resizing:bg-brandPrimary forced-colors:resizing:bg-[Highlight] resizing:w-[2px] resizing:pl-[7px] -outline-offset-2` });
function Zs({ allowsResizing: e, align: t = "start", maxLines: n = 1, shouldFitLabel: r = !1, fitContent: i, minWidth: a, ...o }) {
	let s = Js(), [c, l] = I(0), [u, d] = I(0), f = r && n === 1;
	return /* @__PURE__ */ A(b, {
		...o,
		textValue: o.textValue ?? (typeof o.children == "string" ? o.children : void 0),
		minWidth: Ws({
			minWidth: a,
			labelWidth: f ? c : 0,
			contentWidth: i === void 0 ? 0 : u,
			allowsSorting: o.allowsSorting ?? !1
		}),
		className: O(o.className, (e, { allowsSorting: n, sortDirection: r }) => M(`h-1 ${Ks({ variant: s })} [&:hover]:z-20 text-base font-medium`, t === "end" ? "text-end" : "text-start", r ? "text-textPrimary" : "text-textSecondary", n ? "cursor-pointer" : "cursor-default", e)),
		children: O(o.children, (r, { allowsSorting: a, sortDirection: s }) => /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ j("div", {
			className: "flex items-center pt-3 pb-2.75",
			children: [/* @__PURE__ */ j(ie, {
				role: "presentation",
				tabIndex: -1,
				className: Ys({
					align: t,
					isMultiline: n > 1
				}),
				children: [/* @__PURE__ */ A(Bs, {
					maxLines: n,
					onWidthChange: f ? l : void 0,
					children: r
				}), a && s && /* @__PURE__ */ A(Vs, { direction: s })]
			}), e && !o.width && /* @__PURE__ */ A(x, { className: Xs })]
		}), i !== void 0 && /* @__PURE__ */ A(Is, {
			onWidthChange: d,
			children: i
		})] }))
	});
}
//#endregion
//#region src/lib/components/Table/hooks/useIsInTableFooter.ts
var Qs = St(!1);
function $s() {
	return N(Qs);
}
//#endregion
//#region src/lib/components/Table/DsRow.tsx
var ec = r({
	base: `${z} group/row relative cursor-default -outline-offset-2 text-textPrimary disabled:text-textDisabled text-base hover:bg-backgroundHover pressed:bg-backgroundMutedHover selected:bg-backgroundMutedHover group-data-[variant=raised]/table:last:rounded-b-2xl`,
	variants: { isInteractive: { true: "cursor-pointer select-none" } }
});
function tc({ id: t, columns: n, children: r, ...i }) {
	let { selectionBehavior: a, allowsDragging: s } = yt(), c = $s();
	return /* @__PURE__ */ j(Ne, {
		id: t,
		...i,
		className: (e) => ec({
			...e,
			isInteractive: !c && !e.isDisabled && (e.selectionMode !== "none" || i.href !== void 0 || i.onAction !== void 0)
		}),
		children: [
			s && /* @__PURE__ */ A(Ns, {
				className: "p-2",
				children: !c && /* @__PURE__ */ A(o, {
					slot: "drag",
					children: /* @__PURE__ */ A(e, { name: "grip-vertical" })
				})
			}),
			a === "toggle" && /* @__PURE__ */ A(Ns, {
				className: "p-2",
				children: !c && /* @__PURE__ */ A(xi, { slot: "selection" })
			}),
			/* @__PURE__ */ A(y, {
				items: n,
				children: r
			})
		]
	});
}
//#endregion
//#region src/lib/components/Table/DsTable.tsx
function nc({ variant: e = "raised", ...t }) {
	return /* @__PURE__ */ A(je, {
		"data-variant": e,
		onScroll: t.onScroll,
		className: Gs({
			variant: e,
			className: t.className
		}),
		children: /* @__PURE__ */ A(qe, {
			...t,
			className: "border-separate border-spacing-0 box-border overflow-hidden has-[>[data-empty]]:h-full has-[>[data-empty]]:min-h-[100px]"
		})
	});
}
//#endregion
//#region src/lib/components/Table/DsTableBody.tsx
function rc({ renderEmptyState: e, ...t }) {
	return /* @__PURE__ */ A(Je, {
		...t,
		renderEmptyState: e && ((t) => /* @__PURE__ */ A("div", {
			className: "flex items-center justify-center px-3 py-4 text-center text-base/5 text-textSecondary select-none forced-colors:text-[GrayText]",
			children: e(t)
		}))
	});
}
//#endregion
//#region src/lib/components/Table/DsTableFooter.tsx
function ic(e) {
	return /* @__PURE__ */ A(Qs.Provider, {
		value: !0,
		children: /* @__PURE__ */ A(Ye, {
			...e,
			className: "bg-backgroundMutedHover font-bold"
		})
	});
}
//#endregion
//#region src/lib/components/Table/DsTableHeader.tsx
function ac({ variant: e = "filled", ...t }) {
	let { selectionBehavior: n, selectionMode: r, allowsDragging: i } = yt(), a = Ks({ variant: e });
	return /* @__PURE__ */ A(qs.Provider, {
		value: e,
		children: /* @__PURE__ */ j(Xe, {
			...t,
			className: U(t.className, "sticky top-0 z-10 bg-backgroundRaised forced-colors:bg-[Canvas]"),
			children: [
				i && /* @__PURE__ */ A(b, {
					width: 36,
					minWidth: 36,
					className: `p-2 cursor-default ${a}`
				}),
				n === "toggle" && /* @__PURE__ */ A(b, {
					width: 36,
					minWidth: 36,
					className: `p-2 text-base font-medium cursor-default text-start ${a}`,
					children: r === "multiple" && /* @__PURE__ */ A(xi, { slot: "selection" })
				}),
				/* @__PURE__ */ A(y, {
					items: t.columns,
					children: t.children
				})
			]
		})
	});
}
//#endregion
//#region src/lib/components/Tabs/helpers/tabStyles.ts
var oc = "group relative flex items-center cursor-pointer text-base font-medium outline-none transition forced-color-adjust-none", sc = "justify-center px-1 text-textSecondary hover:text-textPrimary hover:shadow-[inset_0_-2px_0_var(--color-borderSecondary)] focus-visible:text-textPrimary", cc = {
	default: "min-w-12 py-4 text-lg",
	compact: "min-w-8 py-2 text-sm"
}, lc = St({
	variant: "pills",
	orientation: "horizontal",
	size: "default"
}), uc = St("auto"), dc = r({
	base: "flex gap-4 max-w-full",
	variants: { orientation: {
		horizontal: "flex-col",
		vertical: "flex-row"
	} }
});
function fc(e) {
	let { variant: t = "pills", size: n = "default", ...r } = e;
	return /* @__PURE__ */ A(lc.Provider, {
		value: {
			variant: t,
			size: n,
			orientation: e.orientation ?? "horizontal"
		},
		children: /* @__PURE__ */ A(Ze, {
			...r,
			className: O(e.className, (e, t) => dc({
				...t,
				className: e
			}))
		})
	});
}
var pc = r({
	base: "flex max-w-full overflow-x-auto overflow-y-clip [scrollbar-width:none]",
	variants: {
		orientation: {
			horizontal: "flex-row",
			vertical: "flex-col"
		},
		variant: {
			pills: "p-1 -m-1 max-w-[calc(100%+--spacing(2))]",
			underline: ""
		}
	},
	compoundVariants: [
		{
			variant: "pills",
			orientation: "vertical",
			class: "items-start"
		},
		{
			variant: "underline",
			orientation: "horizontal",
			class: "gap-8 shadow-[inset_0_-1px_0_var(--color-borderSecondary)]"
		},
		{
			variant: "underline",
			orientation: "vertical",
			class: "border-e border-borderSecondary"
		}
	]
});
function mc(e) {
	let { variant: t } = N(lc);
	return /* @__PURE__ */ A(We, {
		...e,
		className: O(e.className, (e, n) => pc({
			...n,
			variant: t,
			className: e
		}))
	});
}
var hc = r({
	base: oc,
	variants: {
		variant: {
			pills: "rounded-full px-3 py-1.5 text-textSecondary hover:text-textPrimary focus-visible:text-textPrimary selected:text-textOnInverse forced-colors:selected:text-[HighlightText]",
			underline: `${sc} selected:text-textBrand`
		},
		size: {
			default: "",
			compact: ""
		},
		orientation: {
			horizontal: "",
			vertical: ""
		},
		isDisabled: { true: `${B} forced-colors:text-[GrayText]` }
	},
	compoundVariants: [
		{
			variant: "underline",
			size: "default",
			class: cc.default
		},
		{
			variant: "underline",
			size: "compact",
			class: cc.compact
		},
		{
			variant: "underline",
			orientation: "vertical",
			class: "hover:shadow-none"
		}
	]
}), gc = r({
	base: "absolute motion-safe:transition-[translate,width,height]",
	variants: {
		variant: {
			pills: "top-0 start-0 w-full h-full bg-backgroundInverse rounded-full forced-colors:bg-[Highlight] forced-colors:group-disabled:bg-[GrayText]",
			underline: "bg-brandPrimary forced-colors:bg-[Highlight] forced-colors:group-disabled:bg-[GrayText]"
		},
		orientation: {
			horizontal: "",
			vertical: ""
		}
	},
	compoundVariants: [{
		variant: "underline",
		orientation: "horizontal",
		class: "start-0 bottom-0 w-full h-0.5"
	}, {
		variant: "underline",
		orientation: "vertical",
		class: "top-0 end-0 h-full w-0.5"
	}]
});
function _c(e) {
	let { variant: t, orientation: n, size: r } = N(lc);
	return /* @__PURE__ */ A(Ue, {
		...e,
		className: O(e.className, (e, i) => hc({
			...i,
			variant: t,
			size: r,
			orientation: n,
			className: e
		})),
		children: O(e.children, (e) => /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A("span", {
			className: "relative z-10",
			children: e
		}), /* @__PURE__ */ A(Re, { className: gc({
			variant: t,
			orientation: n
		}) })] }))
	});
}
var vc = r({
	base: "relative overflow-clip",
	variants: { sizing: {
		auto: "h-(--tab-panel-height) motion-safe:transition-[height]",
		fill: "flex min-h-0 flex-1 flex-col"
	} }
});
function yc(e) {
	let { sizing: t = "auto", ...n } = e;
	return /* @__PURE__ */ A(uc.Provider, {
		value: t,
		children: /* @__PURE__ */ A(Ke, {
			...n,
			className: M(vc({ sizing: t }), e.className)
		})
	});
}
var bc = r({
	base: `${z} flex-1 box-border text-base text-textPrimary transition entering:opacity-0 exiting:opacity-0 exiting:absolute exiting:top-0 exiting:start-0 exiting:w-full`,
	variants: { sizing: {
		auto: "",
		fill: "flex min-h-0 flex-col exiting:h-full"
	} }
});
function xc(e) {
	let t = N(uc);
	return /* @__PURE__ */ A(Ge, {
		...e,
		className: O(e.className, (e, n) => bc({
			...n,
			sizing: t,
			className: e
		}))
	});
}
//#endregion
//#region src/lib/components/Tabs/TabBar/DsTabBar.tsx
var Sc = St("default");
function Cc({ children: e, className: t, size: n = "default", "aria-label": r, "aria-labelledby": i, ...a }) {
	return /* @__PURE__ */ A(Sc.Provider, {
		value: n,
		children: /* @__PURE__ */ A(Ze, {
			...a,
			className: "h-full min-w-0",
			children: /* @__PURE__ */ A(We, {
				"aria-label": r,
				"aria-labelledby": i,
				className: M("flex h-full max-w-full gap-8 overflow-x-auto overflow-y-clip [scrollbar-width:none]", t),
				children: e
			})
		})
	});
}
var wc = r({
	base: `shrink-0 ${oc} ${sc}`,
	variants: {
		size: cc,
		isSelected: { true: "text-textBrand hover:text-textBrand focus-visible:text-textBrand" },
		isDisabled: { true: `${B} forced-colors:text-[GrayText]` }
	}
}), Tc = "absolute bottom-0 start-0 h-0.5 w-full bg-brandPrimary motion-safe:transition-[translate,width] forced-colors:bg-[Highlight] forced-colors:group-disabled:bg-[GrayText]";
function Ec({ children: e, ...t }) {
	let n = N(Sc);
	return /* @__PURE__ */ j(Ue, {
		...t,
		className: O(t.className, (e, t) => wc({
			...t,
			size: n,
			className: e
		})),
		children: [e, /* @__PURE__ */ A(Re, { className: Tc })]
	});
}
//#endregion
//#region src/lib/components/TextArea/DsTextArea.tsx
var Dc = r({
	extend: yr,
	base: "min-h-16 px-3 py-2 text-base text-textPrimary placeholder:text-textPlaceholder group-invalid:text-textDangerPrimary disabled:text-textDisabled disabled:placeholder:text-textDisabled"
});
function Oc({ height: e, isFullWidth: t, width: n, label: r, description: i, errorMessage: a, ...o }) {
	return /* @__PURE__ */ j(rt, {
		...o,
		style: Y(o.style, q({
			isFullWidth: t,
			width: n
		})),
		className: U(o.className, "group flex flex-col gap-2"),
		children: [
			r && /* @__PURE__ */ A(X, {
				isRequired: o.isRequired,
				isRequiredAnnouncedByInput: !0,
				children: r
			}),
			/* @__PURE__ */ A(nt, {
				style: J(e, 64),
				className: ({ isFocused: e, isInvalid: t, isDisabled: n }) => Dc({
					isFocusWithin: e,
					isInvalid: t,
					isDisabled: n
				})
			}),
			i && /* @__PURE__ */ A(G, { children: i }),
			/* @__PURE__ */ A(K, { children: a })
		]
	});
}
//#endregion
//#region src/lib/components/TextField/DsTextField.tsx
function kc({ height: t, isFullWidth: n, width: r, label: i, description: a, errorMessage: o, placeholder: s, iconStart: c, iconEnd: l, textStart: u, textEnd: d, selectStart: f, selectEnd: p, buttonEnd: m, isClearable: h, onClear: g, ..._ }) {
	let { t: v } = V(), y = F(null), b = F(null), [x, S] = I(() => String(_.defaultValue ?? "")), C = () => _.value === void 0 ? x : String(_.value), w = () => !!h && C().length > 0 && !_.isDisabled && !_.isReadOnly, T = (e) => {
		_.value === void 0 && S(e), _.onChange?.(e);
	}, ee = () => {
		let e = y.current;
		e && ((Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")?.set)?.call(e, ""), e.dispatchEvent(new Event("input", { bubbles: !0 })), e.focus()), g?.();
	};
	return /* @__PURE__ */ j(rt, {
		..._,
		onChange: T,
		style: Y(_.style, q({
			isFullWidth: n,
			width: r
		})),
		className: U(_.className, "group flex flex-col gap-2"),
		children: [
			i && /* @__PURE__ */ A(X, {
				isRequired: _.isRequired,
				isRequiredAnnouncedByInput: !0,
				children: i
			}),
			/* @__PURE__ */ j(kr, {
				ref: b,
				height: t,
				children: [
					f && /* @__PURE__ */ A(Mr, {
						affix: f,
						align: "start",
						anchorRef: b
					}),
					u && /* @__PURE__ */ A("span", {
						className: "shrink-0 -me-1 text-textSecondary",
						children: u
					}),
					c && /* @__PURE__ */ A(e, {
						name: c,
						size: "md",
						"aria-hidden": !0,
						className: "shrink-0 text-textSecondary"
					}),
					/* @__PURE__ */ A(Nr, {
						ref: y,
						placeholder: s
					}),
					w() && /* @__PURE__ */ A(wr, {
						"aria-label": v("common.clear"),
						onPress: ee,
						className: "size-6 rounded-md -ms-1 last:-me-1.5 hover:bg-backgroundMuted hover:text-textSecondary pressed:bg-backgroundMutedHover pressed:text-textPrimary",
						children: /* @__PURE__ */ A(e, {
							name: "x",
							size: "sm",
							"aria-hidden": !0
						})
					}),
					l && /* @__PURE__ */ A(e, {
						name: l,
						size: "md",
						"aria-hidden": !0,
						className: "shrink-0 text-textSecondary"
					}),
					d && /* @__PURE__ */ A("span", {
						className: "shrink-0 -ms-1 text-textSecondary",
						children: d
					}),
					p && /* @__PURE__ */ A(Mr, {
						affix: p,
						align: "end",
						anchorRef: b
					}),
					m && /* @__PURE__ */ A(Sr, { affix: m })
				]
			}),
			a && /* @__PURE__ */ A(G, { children: a }),
			/* @__PURE__ */ A(K, { children: o })
		]
	});
}
//#endregion
//#region src/lib/components/Toast/DsToast.tsx
var Ac = W({ level: "toast" }).surface(), jc = {
	success: {
		name: "circle-check",
		color: "text-textSuccessPrimary"
	},
	warning: {
		name: "circle-alert",
		color: "text-textWarningPrimary"
	},
	danger: {
		name: "circle-x",
		color: "text-textDangerPrimary"
	},
	info: {
		name: "info",
		color: "text-textInfoPrimary"
	}
}, Mc = {
	success: "bg-backgroundSuccessPrimary text-textSuccessPrimary not-disabled:hover:bg-backgroundSuccessTertiary pressed:bg-backgroundSuccessTertiary",
	warning: "bg-backgroundWarningPrimary text-textWarningPrimary not-disabled:hover:bg-backgroundWarningTertiary pressed:bg-backgroundWarningTertiary",
	danger: "bg-backgroundDangerPrimary text-textDangerPrimary not-disabled:hover:bg-backgroundDangerTertiary pressed:bg-backgroundDangerTertiary",
	info: "bg-backgroundInfoPrimary text-textInfoPrimary not-disabled:hover:bg-backgroundInfoTertiary pressed:bg-backgroundInfoTertiary"
};
function Nc({ variant: t = "info", title: r, description: i, actionLabel: a, onAction: o, showClose: s = !0, onClose: c, className: l, ...u }) {
	let { t: d } = V(), f = jc[t];
	return /* @__PURE__ */ j("div", {
		role: "status",
		className: n(`flex w-full max-w-90 items-start gap-3 ${Ac} px-4 py-3`, l),
		...u,
		children: [
			/* @__PURE__ */ A(e, {
				name: f.name,
				size: "md",
				className: n("shrink-0", f.color),
				"aria-hidden": !0
			}),
			/* @__PURE__ */ j("div", {
				className: "flex min-w-0 flex-1 flex-col gap-0.5",
				children: [/* @__PURE__ */ j(mt, {
					className: "flex flex-col gap-0.5",
					children: [/* @__PURE__ */ A(tt, {
						slot: "title",
						elementType: "p",
						className: "text-base/5 text-textPrimary wrap-break-word",
						children: r
					}), i && /* @__PURE__ */ A(tt, {
						slot: "description",
						elementType: "p",
						className: "text-base/5 text-textSecondary wrap-break-word",
						children: i
					})]
				}), a && o && /* @__PURE__ */ A(H, {
					variant: "soft",
					size: "sm",
					className: n("mt-1.5 self-start", Mc[t]),
					onPress: o,
					children: a
				})]
			}),
			s && /* @__PURE__ */ A(Fn, {
				name: "x",
				size: "sm",
				"aria-label": d("common.close"),
				variant: "plain",
				onPress: c,
				className: "-mt-0.5 -me-1 shrink-0 text-textTertiary hover:text-textPrimary"
			})
		]
	});
}
//#endregion
//#region src/lib/components/Toast/helpers/viewTransitionWrap.ts
function Pc(e) {
	let t = document;
	if (typeof t.startViewTransition == "function") {
		t.startViewTransition(() => {
			Wt(e);
		}).ready.catch(() => void 0);
		return;
	}
	e();
}
//#endregion
//#region src/lib/components/Toast/helpers/dsToast.ts
var $ = new ht({
	maxVisibleToasts: 5,
	wrapUpdate: Pc
}), Fc = 5e3, Ic = (e, t) => e.actionLabel && e.onAction ? {
	...t,
	timeout: void 0
} : t?.timeout ? {
	...t,
	timeout: Math.max(t.timeout, Fc)
} : t, Lc = (e, t) => $.add(e, Ic(e, t)), Rc = (e, t) => ({
	timeout: e,
	...t
}), zc = {
	show: Lc,
	info: (e, t) => Lc({
		...e,
		variant: "info"
	}, Rc(5e3, t)),
	success: (e, t) => Lc({
		...e,
		variant: "success"
	}, Rc(5e3, t)),
	warning: (e, t) => Lc({
		...e,
		variant: "warning"
	}, Rc(7e3, t)),
	danger: (e, t) => Lc({
		...e,
		variant: "danger"
	}, Rc(7e3, t)),
	close: (e) => $.close(e)
}, Bc = {
	top: "[view-transition-class:toast_toast-from-top]",
	bottom: "[view-transition-class:toast_toast-from-bottom]",
	left: "[view-transition-class:toast_toast-from-left]",
	right: "[view-transition-class:toast_toast-from-right]"
};
function Vc(e, t) {
	return e === "top" || e === "bottom" ? e : e.endsWith("end") === (t === "ltr") ? "right" : "left";
}
function Hc({ toast: e, placement: t }) {
	let r = F(null), { direction: i } = It(), { variant: a, title: o, description: s, actionLabel: c, onAction: l } = e.content;
	P(() => {
		let t = r.current?.closest("[role=\"region\"]");
		(t?.hasAttribute("data-hovered") || t?.contains(document.activeElement)) && e.timer?.pause();
	}, [e]);
	let u = l ? () => {
		l(), $.visibleToasts.some((t) => t.key === e.key) && $.close(e.key);
	} : void 0;
	return /* @__PURE__ */ A(pt, {
		ref: r,
		toast: e,
		style: { viewTransitionName: `toast-${e.key}` },
		className: n(Bc[Vc(t, i)], "pointer-events-auto w-full max-w-90 rounded-lg outline-none", z),
		children: /* @__PURE__ */ A(Nc, {
			variant: a,
			title: o,
			description: s,
			actionLabel: c,
			onAction: u,
			onClose: () => $.close(e.key),
			role: void 0
		})
	});
}
//#endregion
//#region src/lib/components/Toast/DsToastRegion.tsx
var Uc = {
	"top start": "top-4 start-4 flex-col",
	top: "top-4 inset-x-0 mx-auto flex-col",
	"top end": "top-4 end-4 flex-col",
	"bottom start": "bottom-4 start-4 flex-col-reverse",
	bottom: "bottom-4 inset-x-0 mx-auto flex-col-reverse",
	"bottom end": "bottom-4 end-4 flex-col-reverse"
}, Wc = (e) => $.subscribe(e), Gc = () => $.visibleToasts.length > 0;
function Kc({ placement: e = "bottom", className: t }) {
	let { t: n } = V();
	return kt(Wc, Gc) ? /* @__PURE__ */ A(gt, {
		queue: $,
		"aria-label": n("toast.region"),
		className: U(t, `pointer-events-none fixed z-toast flex w-[calc(100%-2rem)] max-w-90 gap-2 rounded-lg outline-none ${Uc[e]} ${z}`),
		children: ({ toast: t }) => /* @__PURE__ */ A(Hc, {
			toast: t,
			placement: e
		})
	}) : null;
}
//#endregion
//#region src/lib/components/ToggleButtonGroup/DsToggleButtonGroup.tsx
var qc = "isolate inline-grid max-w-full grid-flow-col auto-cols-fr rounded-lg bg-backgroundMuted p-0.5", Jc = r({
	base: `${z} relative data-focus-visible:z-20 flex min-w-0 items-center justify-center rounded-md px-3 py-1 text-base font-medium text-textSecondary cursor-pointer transition-colors forced-color-adjust-none ${on}`,
	variants: {
		isSelected: { true: "text-textPrimary forced-colors:text-[HighlightText]" },
		isDisabled: { true: `${B} forced-colors:text-[GrayText]` }
	}
}), Yc = "absolute top-0 start-0 size-full rounded-md bg-backgroundFloating shadow-sm motion-safe:transition-[translate,width,height] forced-colors:bg-[Highlight]";
function Xc(e) {
	let { selectedKey: t, defaultSelectedKey: n, onSelectionChange: r, ...i } = e, [a, o] = $t(t, n ?? null, r);
	return /* @__PURE__ */ A(ot, {
		...i,
		selectionMode: "single",
		disallowEmptySelection: !0,
		selectedKeys: a === null ? [] : [a],
		onSelectionChange: (e) => {
			let [t] = e;
			t !== void 0 && o(t);
		},
		className: U(e.className, qc)
	});
}
function Zc(e) {
	return /* @__PURE__ */ A(at, {
		...e,
		className: O(e.className, (e, t) => Jc({
			...t,
			className: e
		})),
		children: O(e.children, (e) => /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A("span", {
			className: "relative z-10 truncate",
			children: e
		}), /* @__PURE__ */ A(Re, { className: Yc })] }))
	});
}
//#endregion
//#region src/lib/components/TokenField/DsTokenField.tsx
var Qc = r({ base: "group flex flex-col gap-1" }), $c = r({
	extend: yr,
	base: "group text-textPrimary px-3 py-2 text-base disabled:select-none disabled:text-textDisabled [&[aria-multiline=true]]:min-h-[100px]"
}), el = r({
	base: `${z} inline-flex items-center rounded-full h-5 px-2 py-px mx-0.5 cursor-pointer whitespace-nowrap bg-brandPrimaryMuted text-textBrand transition selection:bg-transparent group-data-disabled:bg-backgroundMuted group-data-disabled:text-textDisabled forced-colors:group-data-disabled:text-[GrayText]`,
	variants: { isSelected: { true: "bg-brandPrimary text-textOnBrandPrimary forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] forced-color-adjust-none" } }
});
function tl({ height: e, isFullWidth: t, width: n, label: r, description: i, className: a, inputRef: o, children: s, ...c }) {
	return /* @__PURE__ */ j(ct, {
		...c,
		style: Y(c.style, q({
			isFullWidth: t,
			width: n
		})),
		className: U(a, Qc()),
		children: [
			r && /* @__PURE__ */ A(X, { children: r }),
			/* @__PURE__ */ A(lt, {
				ref: o,
				style: J(e, null),
				className: ({ isFocused: e, isDisabled: t }) => $c({
					isFocusWithin: e,
					isDisabled: t
				}),
				children: s
			}),
			i && /* @__PURE__ */ A(G, { children: i })
		]
	});
}
function nl(e) {
	return /* @__PURE__ */ A(st, {
		...e,
		className: O(e.className, (e, t) => el({
			...t,
			className: e
		}))
	});
}
//#endregion
export { Ro as BREAKPOINTS, Fr as CONTROL_BOX_SIZE, Lr as CONTROL_KNOB_SIZE, Ir as CONTROL_TRACK_SIZE, Gt as CalendarDate, B as DISABLED_CLASSES, nn as DS_COMMON_NAMESPACE, Vn as DsAlert, Kr as DsAutocomplete, ei as DsAvatar, ti as DsAvatarGroup, ri as DsBadge, H as DsButton, vi as DsCard, Ns as DsCell, xi as DsCheckbox, Si as DsCheckboxGroup, Oi as DsChip, Ei as DsChipAppliedFilter, Ti as DsChipAppliedFilterGroup, ki as DsChipGroup, Zs as DsColumn, Po as DsCompactTrigger, da as DsDatePicker, ra as DsDateRangePicker, ua as DsDateTimePicker, xa as DsDialog, ja as DsDisplay, Pa as DsDrawer, La as DsDropZone, Ra as DsFileTrigger, Oa as DsFloatingDialog, hi as DsHeading, Fn as DsIconButton, X as DsLabel, Ua as DsLink, cr as DsMenu, lr as DsMenuItem, dr as DsMenuSection, ur as DsMenuSeparator, fr as DsMenuTrigger, pr as DsMenuTriggerButton, Sa as DsModal, Wa as DsNumberField, oo as DsPagination, ho as DsPinInput, ci as DsPlainButton, ir as DsPopover, go as DsPortalProvider, co as DsPrevNextButtons, vo as DsProgressBar, So as DsRadio, xo as DsRadioGroup, pa as DsRangeCalendarPopover, tc as DsRow, Wr as DsSearchField, Oo as DsSelect, Fo as DsSelectCompact, ko as DsSelectItem, Ao as DsSelectSection, Lo as DsSeparator, Ts as DsSidebar, pi as DsSocialButton, mr as DsSubmenuTrigger, Os as DsSwitch, _c as DsTab, Cc as DsTabBar, Ec as DsTabBarItem, mc as DsTabList, xc as DsTabPanel, yc as DsTabPanels, nc as DsTable, rc as DsTableBody, ic as DsTableFooter, ac as DsTableHeader, fc as DsTabs, Oc as DsTextArea, kc as DsTextField, Nc as DsToast, Kc as DsToastRegion, Zc as DsToggleButton, Xc as DsToggleButtonGroup, nl as DsToken, tl as DsTokenField, Mn as DsTooltip, jn as DsTooltipTrigger, an as EMPTY_STATE_CLASSES, Er as FIELD_DEFAULT_HEIGHT, Tr as FIELD_DEFAULT_WIDTH, gr as FIELD_FOCUS_OUTLINE_CLASSES, z as FOCUS_RING_CLASSES, Dr as TEXTAREA_DEFAULT_HEIGHT, dn as TOOLTIP_DELAY, zc as dsToast, $ as dsToastQueue, yr as fieldShellStyles, Jr as getAvatarVariant, qt as getLocalTimeZone, Jt as parseDate, W as surfaceStyles, Yt as today, V as useComponentTranslation, Ls as useDsTooltipTrigger, Vo as useMediaQuery, Ho as useScreenSize };
